import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
export type Maybe<T> = T | null;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any,
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any,
  /** The `Upload` scalar type represents a file upload. */
  Upload: any,
};

export type AccountBalances = {
   __typename?: 'AccountBalances',
  /** Available balance in the given currency */
  balance?: Maybe<Scalars['Float']>,
  /** Pending incoming balance */
  incomingPending?: Maybe<Scalars['Float']>,
  /** Pending outgoing balance */
  outgoingPending?: Maybe<Scalars['Float']>,
  /** Reserved balance */
  reserve?: Maybe<Scalars['Float']>,
  /** Available balance in the given currency */
  currentBalance?: Maybe<Money>,
  /** Pending incoming balance */
  incomingPendingBalance?: Maybe<Money>,
  /** Pending outgoing balance */
  outgoingPendingBalance?: Maybe<Money>,
  /** Reserved balance */
  currentReserve?: Maybe<Money>,
  /** The timestamp when the balances where last updated */
  updatedTimestamp?: Maybe<Scalars['DateTime']>,
};

/** Values for the state of updating payout account settings. */
export enum AccountPayoutsSettingsStatus {
  Processing = 'PROCESSING',
  ProcessingComplete = 'PROCESSING_COMPLETE',
  Unknown = 'UNKNOWN'
}

export type AccountPersonalVerification = {
   __typename?: 'AccountPersonalVerification',
  /** Documents showing address, either a passport, local ID card, or utility bill from a well-known utility company. */
  additionalDocuments: Array<Maybe<AccountVerificationDocument>>,
  /** Identifying documents for the person. */
  documents: Array<Maybe<AccountVerificationDocument>>,
  /** The state of verification for the person. */
  status: AccountPersonalVerificationStatus,
};

/** Values for the state of verification for a person. */
export enum AccountPersonalVerificationStatus {
  Pending = 'PENDING',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED',
  Unspecified = 'UNSPECIFIED'
}

export type AccountRelationship = {
   __typename?: 'AccountRelationship',
  owner?: Maybe<Scalars['Boolean']>,
  percentOwnership?: Maybe<Scalars['Int']>,
  primaryAccountHolder?: Maybe<Scalars['Boolean']>,
  role: AppRole,
  title?: Maybe<Scalars['String']>,
  /** How the person is involved with the account, controller, additional reps etc... */
  involvement?: Maybe<Scalars['String']>,
};

export type AccountRequirements = {
   __typename?: 'AccountRequirements',
  currentDeadline?: Maybe<Scalars['DateTime']>,
  currentlyDue?: Maybe<Array<Scalars['String']>>,
  disabledReason?: Maybe<Scalars['String']>,
  errors?: Maybe<Array<Scalars['String']>>,
  eventuallyDue?: Maybe<Array<Scalars['String']>>,
  pastDue?: Maybe<Array<Scalars['String']>>,
  pendingVerification?: Maybe<Array<Scalars['String']>>,
};

export type AccountSettings = {
   __typename?: 'AccountSettings',
  /** Settings specific to card charging on the account. */
  cardPayments?: Maybe<PaymentSettings>,
  /** Settings specific to ACH payments on the account. */
  achPayments?: Maybe<PaymentSettings>,
  /** Settings specific to the account’s payouts. */
  accountPayouts?: Maybe<PayoutSettings>,
  /** Supported payment methods enabled for the tenant. */
  supportedPaymentMethods?: Maybe<Array<PaymentMethodType>>,
};

export type AccountVerificationDocument = {
   __typename?: 'AccountVerificationDocument',
  customData?: Maybe<Scalars['JSONObject']>,
  documentId?: Maybe<Scalars['String']>,
  rejectReason?: Maybe<Scalars['String']>,
  status?: Maybe<DocumentStatus>,
  type?: Maybe<DocumentType>,
};

export type Address = {
   __typename?: 'Address',
  city?: Maybe<Scalars['String']>,
  /** The country in which the address resides. This should be an ISO 3166-1 alpha-2 country code. */
  country?: Maybe<Scalars['String']>,
  line1?: Maybe<Scalars['String']>,
  line2?: Maybe<Scalars['String']>,
  postalCode?: Maybe<Scalars['String']>,
  region?: Maybe<Scalars['String']>,
};

/** Input for an address */
export type AddressInputType = {
  /** Addresss line 1 */
  line1?: Maybe<Scalars['String']>,
  /** Address line 2 */
  line2?: Maybe<Scalars['String']>,
  /** Address city */
  city?: Maybe<Scalars['String']>,
  /** Address region */
  region?: Maybe<Scalars['String']>,
  /** the address postal code */
  postalCode: Scalars['String'],
  /** the country */
  country: Scalars['String'],
};

export enum AppRole {
  Admin = 'ADMIN',
  Editor = 'EDITOR',
  Reader = 'READER',
  ApiConsumer = 'API_CONSUMER',
  AnonymousPayer = 'ANONYMOUS_PAYER',
  Payer = 'PAYER',
  JsLibrary = 'JS_LIBRARY',
  LimitedPayer = 'LIMITED_PAYER'
}

/** Aptean products. */
export enum ApteanProduct {
  Apprise = 'APPRISE',
  DynamicsFb = 'DYNAMICS_FB',
  M2M = 'M2M',
  Respond = 'RESPOND',
  Ross = 'ROSS',
  Unknown = 'UNKNOWN'
}

/** Input data for attaching a payment method */
export type AttachPaymentMethodInput = {
  /** The payment method id */
  paymentMethodId: Scalars['ID'],
  /** The id of the person or tenant to attach the payment method to. */
  resourceId: Scalars['ID'],
  /** Indicates if this payment method is the default for the payer. */
  isDefault?: Maybe<Scalars['Boolean']>,
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
};

/** Status response for mutation for creating a payment method. */
export type AttachPaymentMethodStatus = {
   __typename?: 'AttachPaymentMethodStatus',
  code: MutationStatusCode,
  message?: Maybe<Scalars['String']>,
  error?: Maybe<Scalars['String']>,
  paymentMethod?: Maybe<PaymentMethod>,
  resource?: Maybe<PaymentMethodOwnerResourceUnion>,
};

/** The type of bank account, checking or savings. */
export enum BankAccountType {
  Checking = 'CHECKING',
  Savings = 'SAVINGS',
  Unknown = 'UNKNOWN'
}

/** The business profile contains key details about the business, associated with the tenant account */
export type BusinessProfile = {
   __typename?: 'BusinessProfile',
  description?: Maybe<Scalars['String']>,
  /** The name of the business profile */
  name: Scalars['String'],
  /** The support address */
  supportAddress?: Maybe<Address>,
  /** The email address of the merchants support team */
  supportEmail?: Maybe<Scalars['String']>,
  /** The phone number of the merchants support team */
  supportPhone?: Maybe<Phone>,
  /** The link to the merchants support website */
  supportUrl?: Maybe<Scalars['String']>,
  /** The url for the merchants website */
  url?: Maybe<Scalars['String']>,
  /** The merchant classification code */
  mcc?: Maybe<Scalars['String']>,
};

/** The categories identifying the legal structure of the company or legal entity. */
export enum BusinessStructure {
  Corporation = 'CORPORATION',
  GovernmentAgency = 'GOVERNMENT_AGENCY',
  LimitedLiabilityCompany = 'LIMITED_LIABILITY_COMPANY',
  NonprofitCorporation = 'NONPROFIT_CORPORATION',
  Partnership = 'PARTNERSHIP',
  PersonalTrust = 'PERSONAL_TRUST',
  SoleProprietor = 'SOLE_PROPRIETOR',
  StatutoryTrust = 'STATUTORY_TRUST',
  UnincorporatedAssociation = 'UNINCORPORATED_ASSOCIATION',
  Unknown = 'UNKNOWN'
}

/** The type of business for the legal entity. */
export enum BusinessType {
  Company = 'COMPANY',
  Individual = 'INDIVIDUAL',
  NonProfit = 'NON_PROFIT',
  GovtEntity = 'GOVT_ENTITY',
  Unknown = 'UNKNOWN'
}

/** Input data for cancelling a pre-authorized payment. */
export type CancelPaymentInput = {
  paymentId: Scalars['ID'],
  reason: Scalars['String'],
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
};

/** Status response for cancel payment mutation. */
export type CancelPaymentStatus = {
   __typename?: 'CancelPaymentStatus',
  code: MutationStatusCode,
  message?: Maybe<Scalars['String']>,
  error?: Maybe<Scalars['String']>,
  payment?: Maybe<Payment>,
};

/** The statuses for account capabilities. */
export enum CapabilityStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

/** Input data for payment capture amounts. */
export type CapturePaymentAmountsInput = {
  amount: Scalars['Int'],
  currency: CurrencyType,
};

/** Input data for manually capturing a payment. */
export type CapturePaymentInput = {
  paymentId: Scalars['ID'],
  /** The final capture amounts if less than the original authorized amounts. */
  amounts?: Maybe<CapturePaymentAmountsInput>,
  /** Level 2/Level 3 data. */
  l2l3Data?: Maybe<L2L3DataInput>,
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
};

/** Status response for capturing payments mutation. */
export type CapturePaymentStatus = {
   __typename?: 'CapturePaymentStatus',
  code: MutationStatusCode,
  message?: Maybe<Scalars['String']>,
  error?: Maybe<Scalars['String']>,
  payment?: Maybe<Payment>,
};

/** The brand of credit card. */
export enum CardBrand {
  Visa = 'VISA',
  Mastercard = 'MASTERCARD',
  Discover = 'DISCOVER',
  Amex = 'AMEX',
  Jcb = 'JCB',
  Diners = 'DINERS',
  Unknown = 'UNKNOWN'
}

/** The type of communication to send, sms or email */
export enum CommunicationType {
  Email = 'EMAIL',
  None = 'NONE',
  Sms = 'SMS',
  EmailAndSms = 'EMAIL_AND_SMS'
}

export type Company = {
   __typename?: 'Company',
  address?: Maybe<Address>,
  description?: Maybe<Scalars['String']>,
  name: Scalars['String'],
  phone?: Maybe<Phone>,
  structure?: Maybe<BusinessStructure>,
  taxIdProvided?: Maybe<Scalars['Boolean']>,
  verification?: Maybe<CompanyAccountVerification>,
};

/** A list of documentation used to verify the company account */
export type CompanyAccountVerification = {
   __typename?: 'CompanyAccountVerification',
  additionalDocuments: Array<Maybe<AccountVerificationDocument>>,
  documents: Array<Maybe<AccountVerificationDocument>>,
  status: CompanyVerificationStatus,
};

/** Values for the state of verification for a company */
export enum CompanyVerificationStatus {
  Pending = 'PENDING',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED',
  Unspecified = 'UNSPECIFIED'
}

/** Input data for conceding a dispute */
export type ConcedeDisputeInput = {
  /** The dispute id */
  id: Scalars['ID'],
  /** The explanation for changing the status. */
  explanation: Scalars['String'],
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
};

/** Input data for converting a payfac payment method token */
export type ConvertPayfacPaymentMethodTokenInput = {
  /** The payment method token */
  token: Scalars['String'],
  /** The payment method type */
  type: PaymentMethodType,
  /** The payment method holder */
  holder: PaymentMethodHolderInput,
  /** Indicates if the resulting token will be kept on file as a recurring payment method */
  recurring?: Maybe<Scalars['Boolean']>,
};

/** Status response for mutation for converting a payment method token. */
export type ConvertPayfacPaymentMethodTokenStatus = {
   __typename?: 'ConvertPayfacPaymentMethodTokenStatus',
  code: MutationStatusCode,
  message?: Maybe<Scalars['String']>,
  error?: Maybe<Scalars['String']>,
  token?: Maybe<Token>,
};

/** The country code */
export enum CountryCode {
  Ca = 'CA',
  Us = 'US'
}

/** Input data for creating a payment */
export type CreatePaymentInput = {
  paymentMethodId: Scalars['ID'],
  paymentRequestId?: Maybe<Scalars['ID']>,
  amount: Scalars['Int'],
  currency: CurrencyType,
  /** The description of the payment */
  description?: Maybe<Scalars['String']>,
  /** Indicates whether to immediately capture payment amount */
  immediateCapture: Scalars['Boolean'],
  /** The date to defer capturing the payment. Must be less than 7 days from payment creation date. */
  captureAt?: Maybe<Scalars['DateTime']>,
  /** Level 2/Level 3 data. */
  l2l3Data?: Maybe<L2L3DataInput>,
  /** Additional data for the payment that is used for risk analysis. */
  riskMetadata: RiskMetadataPaymentInput,
  /** Indicates whether to fail the mutation call and cancel the payment when it goes into the REVIEW state. */
  failOnReview?: Maybe<Scalars['Boolean']>,
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
};

/** Input data for upserting a payment method */
export type CreatePaymentMethodInput = {
  /** The payment method token */
  token: Scalars['String'],
  /** The id of the person or tenant to attach the payment method to. */
  attachToResourceId: Scalars['String'],
  /** Indicates if this payment method is the default for the payer. */
  isDefault?: Maybe<Scalars['Boolean']>,
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
};

/** Status response for mutation for creating a payment method. */
export type CreatePaymentMethodStatus = {
   __typename?: 'CreatePaymentMethodStatus',
  code: MutationStatusCode,
  message?: Maybe<Scalars['String']>,
  error?: Maybe<Scalars['String']>,
  paymentMethod?: Maybe<PaymentMethod>,
};

/** Status response for creating payments mutation. */
export type CreatePaymentStatus = {
   __typename?: 'CreatePaymentStatus',
  code: MutationStatusCode,
  message?: Maybe<Scalars['String']>,
  error?: Maybe<Scalars['String']>,
  payment?: Maybe<Payment>,
};

/** Input data for creating a refund */
export type CreateRefundInput = {
  /** The payment id */
  paymentId: Scalars['String'],
  /** The reason for the refund */
  refundReason: Scalars['String'],
  /** The amount of the refund, if partial. Otherwise null. */
  amount?: Maybe<Scalars['Int']>,
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
};

/** Status response for mutation for creating a refund. */
export type CreateRefundStatus = {
   __typename?: 'CreateRefundStatus',
  code: MutationStatusCode,
  message?: Maybe<Scalars['String']>,
  error?: Maybe<Scalars['String']>,
  refund?: Maybe<Refund>,
};

export type CreditCard = {
   __typename?: 'CreditCard',
  cardBrand?: Maybe<CardBrand>,
  cardHolder?: Maybe<PaymentMethodHolder>,
  displayName?: Maybe<Scalars['String']>,
  expirationMonth?: Maybe<Scalars['Int']>,
  expirationYear?: Maybe<Scalars['Int']>,
  lastFour?: Maybe<Scalars['String']>,
  cardOnFile?: Maybe<Scalars['Boolean']>,
  recurring?: Maybe<Scalars['Boolean']>,
  cvvProvided?: Maybe<Scalars['Boolean']>,
};

/** The currency of the transaction, usd or cad */
export enum CurrencyType {
  Cad = 'CAD',
  Usd = 'USD',
  Unknown = 'UNKNOWN'
}


/** Input data for deleting a payment method */
export type DeletePaymentMethodInput = {
  /** The payment method id */
  paymentMethodId: Scalars['ID'],
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
};

/** Status response for mutation for deleting a payment method. */
export type DeletePaymentMethodStatus = {
   __typename?: 'DeletePaymentMethodStatus',
  code: MutationStatusCode,
  message?: Maybe<Scalars['String']>,
  error?: Maybe<Scalars['String']>,
  paymentMethod?: Maybe<PaymentMethod>,
};

/** Input data for deleting a person */
export type DeletePersonInput = {
  id: Scalars['ID'],
};

/** Status response mutation for deleting a person */
export type DeletePersonStatus = {
   __typename?: 'DeletePersonStatus',
  /** Whether the delete was successful, failed */
  code: MutationStatusCode,
  /** The message to explaing the status code */
  message?: Maybe<Scalars['String']>,
  /** The error message if it failed */
  error?: Maybe<Scalars['String']>,
};

/** Input data for detaching a payment method */
export type DetachPaymentMethodInput = {
  /** The payment method id */
  paymentMethodId: Scalars['ID'],
  /** The id of the person or tenant to attach the payment method to. */
  resourceId: Scalars['ID'],
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
};

/** Status response for mutation for detaching a payment method. */
export type DetachPaymentMethodStatus = {
   __typename?: 'DetachPaymentMethodStatus',
  code: MutationStatusCode,
  message?: Maybe<Scalars['String']>,
  error?: Maybe<Scalars['String']>,
  paymentMethod?: Maybe<PaymentMethod>,
  resource?: Maybe<PaymentMethodOwnerResourceUnion>,
};

/** The dispute is raised by the card / bank when the payee queries a payment that was made. */
export type Dispute = {
   __typename?: 'Dispute',
  /** The amount being disputed */
  amount?: Maybe<Scalars['Int']>,
  /** The type of card being used */
  cardBrand?: Maybe<CardBrand>,
  /** The time the dispute was created */
  createdAt?: Maybe<Scalars['DateTime']>,
  /** The explaination as to why the dispute has been conceded */
  concedeMessage?: Maybe<Scalars['String']>,
  /** The currency of the dispute */
  currency?: Maybe<CurrencyType>,
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
  /** The type of dispute, inquiry / charge back */
  disputeType?: Maybe<DisputeType>,
  /** The Id of the dispute */
  id?: Maybe<Scalars['ID']>,
  /** The owner of the payment dispute. */
  owner?: Maybe<Owner>,
  /** The reason why the dispute has been raised */
  reason?: Maybe<DisputeReason>,
  /** The message sent from payfac explainging the reason */
  reasonMessage?: Maybe<Scalars['String']>,
  /** The details behind the reason */
  reasonDetails?: Maybe<Array<DisputeReasonDetail>>,
  /** 
 * The final resolution from a resolved dispute, pending once a challenge has
   * been made. won / lost will be returned from the pay fac
 */
  resolution?: Maybe<DisputeResolutionType>,
  /** The time of the final resolution */
  resolvedAt?: Maybe<Scalars['DateTime']>,
  /** The current status of the dispute */
  status?: Maybe<DisputeStatus>,
};

/** A list of disputes associated with the merchant. */
export type DisputeConnection = {
   __typename?: 'DisputeConnection',
  /** A list of edges. */
  edges: Array<Maybe<DisputeEdge>>,
  /** The item at the end of each edge in the edges collection. */
  nodes: Array<Maybe<Dispute>>,
  /** Information to aid in pagination. */
  pageInfo: PageInfo,
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'],
};

/** The dispute field to query by */
export enum DisputeDateRangeType {
  DisputeCreated = 'DISPUTE_CREATED'
}

/** An edge in a connection. */
export type DisputeEdge = {
   __typename?: 'DisputeEdge',
  /** A cursor for use in pagination. */
  cursor: Scalars['String'],
  /** The item at the end of the edge. */
  node: Dispute,
};

/** Ways in which lists of disputes can be ordered upon return */
export type DisputeOrder = {
  /** The direction in which to order by the specified field */
  direction: OrderDirection,
  /** The field in which to order disputes */
  field: DisputeOrderField,
};

/** The dispute field to order by */
export enum DisputeOrderField {
  Timestamp = 'TIMESTAMP'
}

/** The reason the disputes was raised */
export enum DisputeReason {
  Fraud = 'FRAUD',
  Recognition = 'RECOGNITION',
  ProcessingError = 'PROCESSING_ERROR',
  ServicesNotProvided = 'SERVICES_NOT_PROVIDED',
  NotAsDescribed = 'NOT_AS_DESCRIBED',
  Inquiry = 'INQUIRY',
  Unknown = 'UNKNOWN'
}

/** The details for the card company explaining the reason for the dispute */
export type DisputeReasonDetail = {
   __typename?: 'DisputeReasonDetail',
  /** The code originating from the finance / card company */
  code: Scalars['String'],
  /** The message related to the code */
  message: Scalars['String'],
};

/** The outcome of the dispute, won, lost or pending */
export enum DisputeResolutionType {
  Won = 'WON',
  Lost = 'LOST',
  Pending = 'PENDING'
}

/** 
 * The status of the dispute, conceded-awaiting-payfac and challenge-awating-payfac
 * are while we are waiting for the pay fac to respond
 */
export enum DisputeStatus {
  ConcededAwaitingPayfac = 'CONCEDED_AWAITING_PAYFAC',
  ChallengeAwaitingPayfac = 'CHALLENGE_AWAITING_PAYFAC',
  AwaitingMerchantResponse = 'AWAITING_MERCHANT_RESPONSE',
  PendingPayfacReview = 'PENDING_PAYFAC_REVIEW',
  AwaitingChargebackDecision = 'AWAITING_CHARGEBACK_DECISION',
  Resolved = 'RESOLVED',
  Unknown = 'UNKNOWN'
}

/** The type of dispute, inquiry or chargeback */
export enum DisputeType {
  Inquiry = 'INQUIRY',
  Chargeback = 'CHARGEBACK'
}

/** The current status of the document */
export enum DocumentStatus {
  InReview = 'IN_REVIEW',
  Verified = 'VERIFIED',
  Rejected = 'REJECTED',
  Unspecified = 'UNSPECIFIED'
}

/** Input for document tokens. */
export type DocumentTokenInput = {
  /** the subject the documents relate to */
  subject: DocumentTokenSubject,
  /** the type of document the token relates to */
  documentType: DocumentType,
  /** The token returned from wepay */
  token: Scalars['String'],
};

/** Values for document token subject. */
export enum DocumentTokenSubject {
  Representative_0 = 'REPRESENTATIVE_0',
  Representative_1 = 'REPRESENTATIVE_1',
  Representative_2 = 'REPRESENTATIVE_2',
  Representative_3 = 'REPRESENTATIVE_3',
  ControllerPersonalVerification = 'CONTROLLER_PERSONAL_VERIFICATION',
  EntityVerification = 'ENTITY_VERIFICATION'
}

/** The type of document used as evidence during legal entity onboarding. */
export enum DocumentType {
  Passport = 'PASSPORT',
  DriversLicense = 'DRIVERS_LICENSE',
  OtherGovernmentIssuedPhotoId = 'OTHER_GOVERNMENT_ISSUED_PHOTO_ID',
  CurrentLeaseContract = 'CURRENT_LEASE_CONTRACT',
  CurrentUtilityBill = 'CURRENT_UTILITY_BILL',
  BenefitsCard = 'BENEFITS_CARD',
  BirthCertificate = 'BIRTH_CERTIFICATE',
  CertificateOfCitizenship = 'CERTIFICATE_OF_CITIZENSHIP',
  CertificateOfNaturalization = 'CERTIFICATE_OF_NATURALIZATION',
  CertifiedCopyOfCourtOrder = 'CERTIFIED_COPY_OF_COURT_ORDER',
  EmploymentAuthorizationCard = 'EMPLOYMENT_AUTHORIZATION_CARD',
  PermanentResidentCard = 'PERMANENT_RESIDENT_CARD',
  SocialSecurityCard = 'SOCIAL_SECURITY_CARD',
  SocialInsuranceNumberCard = 'SOCIAL_INSURANCE_NUMBER_CARD',
  EvidenceOfCorporateRegistration = 'EVIDENCE_OF_CORPORATE_REGISTRATION',
  EvidenceOfNonProfitRegistration = 'EVIDENCE_OF_NON_PROFIT_REGISTRATION',
  EvidenceOfAuthority = 'EVIDENCE_OF_AUTHORITY',
  CurrentBankStatement = 'CURRENT_BANK_STATEMENT',
  CurrentLocalTaxBill = 'CURRENT_LOCAL_TAX_BILL',
  MortgageStatement = 'MORTGAGE_STATEMENT',
  ElectoralRegisterEntry = 'ELECTORAL_REGISTER_ENTRY',
  Unspecified = 'UNSPECIFIED'
}


/** Data used for Level 2/Level 3 processing. */
export type L2L3Data = {
   __typename?: 'L2L3Data',
  /** The tax amount for the order. */
  taxAmount?: Maybe<Scalars['Int']>,
  /** The short description of the order (max 255 characters) */
  shortDescription?: Maybe<Scalars['String']>,
  /** Customer reference number. */
  customerReferenceNumber?: Maybe<Scalars['String']>,
  /** The order type. */
  orderType?: Maybe<L2L3OrderType>,
  /** The order items. */
  lineItems?: Maybe<Array<L2L3DataLineItem>>,
};

/** Input data for Level 2/Level 3 data processing. */
export type L2L3DataInput = {
  /** The tax amount for the order. */
  taxAmount: Scalars['Int'],
  /** The short description of the order (max 255 characters) */
  shortDescription: Scalars['String'],
  /** Customer reference number. */
  customerReferenceNumber: Scalars['String'],
  /** The order type. */
  orderType: L2L3OrderType,
  /** The order items. */
  lineItems?: Maybe<Array<L2L3DataLineItemInput>>,
};

/** Order line item for Level 2/Level 3 data processing. */
export type L2L3DataLineItem = {
   __typename?: 'L2L3DataLineItem',
  /** ISO 4217 currency code. */
  currency?: Maybe<CurrencyType>,
  /** Text description (especially for services and invoices). */
  description?: Maybe<Scalars['String']>,
  /** The number of items ordered. */
  quantity?: Maybe<Scalars['Int']>,
  /** The tax amount for the order. */
  totalAmount?: Maybe<Scalars['Int']>,
  /** The unit of measure relative to the line item. */
  unitOfMeasure?: Maybe<Scalars['String']>,
  /** Price per unit. */
  unitPrice?: Maybe<Scalars['Int']>,
};

/** Order line item for Level 2/Level 3 data processing. */
export type L2L3DataLineItemInput = {
  /** ISO 4217 currency code. */
  currency: CurrencyType,
  /** Text description (especially for services and invoices). */
  description: Scalars['String'],
  /** The number of items ordered. */
  quantity: Scalars['Int'],
  /** The tax amount for the order. */
  totalAmount: Scalars['Int'],
  /** The unit of measure relative to the line item. */
  unitOfMeasure: Scalars['String'],
  /** Price per unit. */
  unitPrice: Scalars['Int'],
};

/** The type of order for Level 2/Level 3 processing. */
export enum L2L3OrderType {
  Donation = 'DONATION',
  Event = 'EVENT',
  Goods = 'GOODS',
  Personal = 'PERSONAL',
  Service = 'SERVICE'
}

/** Status response for mutation for uploading media. */
export type MediaStatus = {
   __typename?: 'MediaStatus',
  /** Whether the delete was successful, failed */
  code: MutationStatusCode,
  /** The message to explaing the status code */
  message?: Maybe<Scalars['String']>,
  /** The error message if it failed */
  error?: Maybe<Scalars['String']>,
  /** The unique id (generated file name) of the uploaded file */
  uniqueId?: Maybe<Scalars['ID']>,
};

/** Represents an amount of money with its currency type. */
export type Money = {
   __typename?: 'Money',
  /** The amount */
  amount: Scalars['Int'],
  /** The three-letter currency code defined in ISO 4217. */
  currency: Scalars['String'],
};

export type Mutation = {
   __typename?: 'Mutation',
  /** 
 * [NOT ACCESSIBLE BY API] Create or update the payout settings. This can only be
   * called once the tenant account has been created with wepay
 */
  upsertPayoutSettings: UpsertPayoutSettingsStatus,
  /** 
 * [NOT ACCESSIBLE BY API] Create or update the payout frequency schedule. This
   * can only be called once the tenant account has been created with wepay
 */
  upsertPayoutFrequency: UpsertPayoutFrequencyStatus,
  /** [NOT ACCESSIBLE BY API] Concede the dispute, and explanation must be provided */
  concedeDispute: MutationStatusCode,
  /** [NOT ACCESSIBLE BY API] Challenge the dispute, the explaination and document tokens are required */
  updateDispute: MutationStatusCode,
  /** 
 * Uploads the PDF file required by the payment request, use the unique id
   * returned as the invoiceRef when creating a payment request.
 */
  upload: MediaStatus,
  /** Converts a payfac payment method token. Returned token has a 15 min expiration. */
  convertPayfacPaymentMethodToken: ConvertPayfacPaymentMethodTokenStatus,
  /** Creates a new payment method. */
  createPaymentMethod: CreatePaymentMethodStatus,
  /** Verify bank payment method with microdeposits. */
  verifyPaymentMethod: VerifyPaymentMethodStatus,
  /** Updates a payment method. */
  updatePaymentMethod: UpdatePaymentMethodStatus,
  /** Deletes a payment method. */
  deletePaymentMethod: DeletePaymentMethodStatus,
  /** Attaches a payment method to person or tenant. */
  attachPaymentMethod: AttachPaymentMethodStatus,
  /** Detaches a payment method from person or tenant. */
  detachPaymentMethod: DetachPaymentMethodStatus,
  /** 
 * Creates a new payment request. The reference number must be unique and the
   * invoice ref must correspond to a pdf file that has already been uploaded.
 */
  upsertPaymentRequest: UpsertPaymentRequestStatus,
  /** Creates a new payment request without an invoice ref. The reference number must be unique. */
  upsertPaymentRequestNoInvoice: UpsertPaymentRequestStatus,
  /** Create a payment. */
  createPayment: CreatePaymentStatus,
  /** Capture a payment. */
  capturePayment: CapturePaymentStatus,
  /** Cancel a pre-authorized payment. */
  cancelPayment: CancelPaymentStatus,
  /** [NOT ACCESSIBLE BY API] Delete the person. Note: soft delete only */
  deletePerson: DeletePersonStatus,
  /** [NOT ACCESSIBLE BY API] Create or update the person / user */
  upsertPerson: UpsertPersonStatus,
  /** [NOT ACCESSIBLE BY API] Create or Update a payer person */
  upsertPayer: UpsertPersonStatus,
  /** 
 * [NOT ACCESSIBLE BY API] Process the card payment. The payment token (from
   * wepay), the payment request id and the payer details are required.
 */
  processPaymentRequest: ProcessPaymentStatus,
  /** Start processing the refund. The payment id, refund reason and amount refunded are all required. */
  processRefund: ProcessRefundStatus,
  /** Create a refund. The payment id, refund reason and amount refunded are all required. */
  createRefund: CreateRefundStatus,
  /** [NOT ACCESSIBLE BY API] Update the tenant account properties */
  upsertTenantAccount: UpsertTenantAccountStatus,
  /** [NOT ACCESSIBLE BY API] Submit documentation (tokens) used to verify the merchant */
  submitVerification: SubmitVerificationStatus,
};


export type MutationUpsertPayoutSettingsArgs = {
  input: UpsertPayoutSettingsInput
};


export type MutationUpsertPayoutFrequencyArgs = {
  input: UpsertPayoutFrequencyInput
};


export type MutationConcedeDisputeArgs = {
  input: ConcedeDisputeInput
};


export type MutationUpdateDisputeArgs = {
  input: UpdateDisputeInput
};


export type MutationUploadArgs = {
  input: UploadInput
};


export type MutationConvertPayfacPaymentMethodTokenArgs = {
  input: ConvertPayfacPaymentMethodTokenInput
};


export type MutationCreatePaymentMethodArgs = {
  input: CreatePaymentMethodInput
};


export type MutationVerifyPaymentMethodArgs = {
  input: VerifyPaymentMethodInput
};


export type MutationUpdatePaymentMethodArgs = {
  input: UpdatePaymentMethodInput
};


export type MutationDeletePaymentMethodArgs = {
  input: DeletePaymentMethodInput
};


export type MutationAttachPaymentMethodArgs = {
  input: AttachPaymentMethodInput
};


export type MutationDetachPaymentMethodArgs = {
  input: DetachPaymentMethodInput
};


export type MutationUpsertPaymentRequestArgs = {
  input: UpsertPaymentRequestInput
};


export type MutationUpsertPaymentRequestNoInvoiceArgs = {
  input: UpsertPaymentRequestNoInvoiceInput
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput
};


export type MutationCapturePaymentArgs = {
  input: CapturePaymentInput
};


export type MutationCancelPaymentArgs = {
  input: CancelPaymentInput
};


export type MutationDeletePersonArgs = {
  input: DeletePersonInput
};


export type MutationUpsertPersonArgs = {
  input: UpsertPersonInput
};


export type MutationUpsertPayerArgs = {
  input: UpsertPayerInput
};


export type MutationProcessPaymentRequestArgs = {
  input: ProcessPaymentRequestInput
};


export type MutationProcessRefundArgs = {
  input: ProcessRefundInput
};


export type MutationCreateRefundArgs = {
  input: CreateRefundInput
};


export type MutationUpsertTenantAccountArgs = {
  input: UpsertTenantAccountInput
};


export type MutationSubmitVerificationArgs = {
  input: SubmitVerificationInput
};

/** All possible statuses for mutations */
export enum MutationStatusCode {
  Error = 'ERROR',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Input data for a sales order line item */
export type OrderLineItemInput = {
  /** Description of the line item */
  description: Scalars['String'],
  /** Price of the line item */
  price: Scalars['Int'],
  /** Currency of the associated price. */
  currency: CurrencyType,
  /** Quantity of the line item. */
  quantity: Scalars['Int'],
};

/** The owner data attached to most of the data objects, only the relevant properties will be populated */
export type Owner = {
   __typename?: 'Owner',
  /** The Id of the tenant */
  tenantId: Scalars['ID'],
  /** The Id of the adjustment */
  adjustmentId?: Maybe<Scalars['ID']>,
  /** The Id of the dispute */
  disputeId?: Maybe<Scalars['ID']>,
  /** The Id of the payment */
  paymentId?: Maybe<Scalars['ID']>,
  /** The Id of the refund */
  personId?: Maybe<Scalars['ID']>,
  /** The Id of the payout */
  payoutId?: Maybe<Scalars['ID']>,
  /** The Id of the recovery */
  recoveryId?: Maybe<Scalars['ID']>,
  /** The Id of the refund */
  refundId?: Maybe<Scalars['ID']>,
  /** The Id of the payment request */
  paymentRequestId?: Maybe<Scalars['ID']>,
};

/** Information about pagination in a connection. */
export type PageInfo = {
   __typename?: 'PageInfo',
  /** The cursor for the last items in the connection, use this as the start when you want to get the next page */
  endCursor?: Maybe<Scalars['String']>,
  /** Whether the connection can return any more results */
  hasNextPage?: Maybe<Scalars['Boolean']>,
  /** whether the connetion can return any previous pages */
  hasPreviousPage?: Maybe<Scalars['Boolean']>,
  /** The cursor for the first item in the connection */
  startCursor?: Maybe<Scalars['String']>,
};

export type PayerPaymentMethod = {
   __typename?: 'PayerPaymentMethod',
  /** A payment method */
  paymentMethod?: Maybe<PaymentMethod>,
  /** Indicates if this payment method is the default for the payer. */
  isDefault?: Maybe<Scalars['Boolean']>,
};

export type PayerProfile = {
   __typename?: 'PayerProfile',
  /** List of payment methods. */
  paymentMethods?: Maybe<Array<PayerPaymentMethod>>,
};

/** A payer transaction */
export type PayerTransaction = {
   __typename?: 'PayerTransaction',
  /** The currency of the payment */
  currency?: Maybe<CurrencyType>,
  /** The payment amount */
  amount?: Maybe<Scalars['Int']>,
  /** The id of the merchant payee */
  tenantId: Scalars['String'],
  /** The name of the merchant payee */
  merchantName: Scalars['String'],
  /** The country of the merchant */
  merchantCountry: Scalars['String'],
  /** The date for the payment */
  paymentDate?: Maybe<Scalars['DateTime']>,
  /** The payment. */
  payment?: Maybe<Payment>,
  /** The id for the payment */
  paymentId?: Maybe<Scalars['String']>,
  /** The payment method used for payment. */
  paymentMethod?: Maybe<PaymentMethod>,
  /** The create timestamp for the payment request */
  paymentRequestCreatedTimestamp: Scalars['DateTime'],
  /** The payment request. */
  paymentRequest?: Maybe<PaymentRequest>,
  /** The id for the payment request */
  paymentRequestId: Scalars['String'],
  /** The payer. */
  payer?: Maybe<Person>,
  /** The id for the payer */
  personId: Scalars['String'],
  /** The reference number from the payment request */
  invoiceReferenceNumber: Scalars['String'],
  /** The status of the payment request */
  status: PaymentRequestStatus,
  /** The payment url token */
  paymentUrlToken?: Maybe<Scalars['String']>,
};

/** A list of transactions associated with the payer. */
export type PayerTransactionConnection = {
   __typename?: 'PayerTransactionConnection',
  /** A list of edges. */
  edges: Array<Maybe<PayerTransactionEdge>>,
  /** The item at the end of each edge in the edges collection. */
  nodes: Array<Maybe<PayerTransaction>>,
  /** Information to aid in pagination. */
  pageInfo: PageInfo,
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'],
};

/** An edge in a connection. */
export type PayerTransactionEdge = {
   __typename?: 'PayerTransactionEdge',
  /** A cursor for use in pagination. */
  cursor: Scalars['String'],
  /** The item at the end of the edge. */
  node: PayerTransaction,
};

/** Ways in which lists of payer transactions can be ordered upon return */
export type PayerTransactionOrder = {
  /** The direction in which to order payer transactions by the specified field */
  direction: OrderDirection,
  /** The field in which to order payer transactions */
  field: PayerTransactionOrderField,
};

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum PayerTransactionOrderField {
  Timestamp = 'TIMESTAMP'
}

export type PayFacId = {
   __typename?: 'PayFacId',
  /** Type of resource. */
  resourceType?: Maybe<Scalars['String']>,
  /** Id of the resource. */
  resourceId?: Maybe<Scalars['String']>,
};

export type PayFacIds = {
   __typename?: 'PayFacIds',
  /** List of resource ids and types. */
  ids?: Maybe<Array<PayFacId>>,
};

/** A payment record */
export type Payment = {
   __typename?: 'Payment',
  /** The amount of the payment, the value should be lowest denomination i.e. cents */
  amount?: Maybe<Scalars['Int']>,
  /** The amount being disputed against this payment */
  amountDisputed?: Maybe<Scalars['Int']>,
  /** The amount refunded against the payment */
  amountRefunded?: Maybe<Scalars['Int']>,
  /** The time the payment was attempted */
  attemptTimestamp?: Maybe<Scalars['DateTime']>,
  /** The reason why the payment was cancelled */
  cancelReason?: Maybe<Scalars['String']>,
  /** The time the payment was captured */
  capturedAt?: Maybe<Scalars['DateTime']>,
  /** The time the payment was completed */
  completedTimestamp?: Maybe<Scalars['DateTime']>,
  /** The time the payment was created */
  createdAt?: Maybe<Scalars['DateTime']>,
  /** The currency used for this payment */
  currency?: Maybe<CurrencyType>,
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
  /** The description of the payment */
  description?: Maybe<Scalars['String']>,
  /** The reason why the payment failed */
  failureReason?: Maybe<Scalars['String']>,
  /** The fee for this payment (lowest denomination) */
  feeAmount?: Maybe<Scalars['Int']>,
  /** The Id for the payment */
  id: Scalars['String'],
  /** Indicates whether to immediately capture payment amount */
  immediateCapture?: Maybe<Scalars['Boolean']>,
  /** The user that initiated the payment */
  initiatedBy?: Maybe<Scalars['String']>,
  /** The owner of the payment. */
  owner: Owner,
  /** The parent payment request */
  paymentRequest?: Maybe<PaymentRequest>,
  /** The reason why the payment is pending */
  pendingReason?: Maybe<Scalars['String']>,
  /** A list of the refunds made against this payment */
  refunds: Array<Maybe<Refund>>,
  /** The current status of the payment */
  status: PaymentStatus,
};

export type PaymentBank = {
   __typename?: 'PaymentBank',
  accountHolder?: Maybe<PaymentMethodHolder>,
  accountType?: Maybe<BankAccountType>,
  lastFour?: Maybe<Scalars['String']>,
};

/** A list of payments associated with the merchant. */
export type PaymentConnection = {
   __typename?: 'PaymentConnection',
  /** A list of edges. */
  edges: Array<Maybe<PaymentEdge>>,
  /** The item at the end of each edge in the edges collection. */
  nodes: Array<Maybe<Payment>>,
  /** Information to aid in pagination. */
  pageInfo: PageInfo,
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'],
};

export enum PaymentDateRangeType {
  PaymentCompleted = 'PAYMENT_COMPLETED',
  PaymentRequestCreated = 'PAYMENT_REQUEST_CREATED',
  PaymentRequestUpdated = 'PAYMENT_REQUEST_UPDATED'
}

/** 
 * An edge in a connection. Think of the edge as the connection between two nodes.
 *   Its tightly coupled to the filter and order by applied to the connection, any
 * changes to the filter or order by will invalidate the edge
 */
export type PaymentEdge = {
   __typename?: 'PaymentEdge',
  /** A cursor for use in pagination. */
  cursor: Scalars['String'],
  /** The item at the end of the edge. */
  node: Payment,
};

export type PaymentMethod = {
   __typename?: 'PaymentMethod',
  /** Unique identifier for the object */
  id: Scalars['ID'],
  creditCard?: Maybe<CreditCard>,
  createdAt?: Maybe<Scalars['DateTime']>,
  createdBy?: Maybe<Scalars['String']>,
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
  /** The owner of the payment method. */
  owner: Owner,
  paymentBank?: Maybe<PaymentBank>,
  /** The status of payment method. */
  status?: Maybe<PaymentMethodStatus>,
  /** The type of payment method. */
  type?: Maybe<PaymentMethodType>,
  /** The timestamp when the payment method was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>,
  /** The user identifier who last updated the payment method */
  updatedBy?: Maybe<Scalars['String']>,
  /** Whether the payment method is long lived or not */
  isLongLived?: Maybe<Scalars['Boolean']>,
};

/** A list of payment methods associated with the merchant. */
export type PaymentMethodConnection = {
   __typename?: 'PaymentMethodConnection',
  /** A list of edges. */
  edges: Array<Maybe<PaymentMethodEdge>>,
  /** The item at the end of each edge in the edges collection. */
  nodes: Array<Maybe<PaymentMethod>>,
  /** Information to aid in pagination. */
  pageInfo: PageInfo,
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'],
};

/** 
 * An edge in a connection. Think of the edge as the connection between two nodes.
 *   Its tightly coupled to the filter and order by applied to the connection, any
 * changes to the filter or order by will invalidate the edge
 */
export type PaymentMethodEdge = {
   __typename?: 'PaymentMethodEdge',
  /** A cursor for use in pagination. */
  cursor: Scalars['String'],
  /** The item at the end of the edge. */
  node: PaymentMethod,
};

export type PaymentMethodHolder = {
   __typename?: 'PaymentMethodHolder',
  address?: Maybe<Address>,
  email?: Maybe<Scalars['String']>,
  holderName?: Maybe<Scalars['String']>,
  phone?: Maybe<Phone>,
};

/** Input data for the payment method holder */
export type PaymentMethodHolderInput = {
  /** The email address of the payment method card/account holder. */
  email?: Maybe<Scalars['String']>,
  /** The name of the payment method card/account holder */
  name?: Maybe<Scalars['String']>,
  /** The address of the payment method card/account holder */
  address: AddressInputType,
  /** The phone number of the payment method card/account holder */
  phone?: Maybe<PhoneInputType>,
};

/** Ways in which lists of payment methods can be ordered upon return */
export type PaymentMethodOrder = {
  /** The direction in which to order payment methods by the specified field */
  direction: OrderDirection,
  /** The field in which to order payment methods */
  field: PaymentMethodOrderField,
};

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum PaymentMethodOrderField {
  Timestamp = 'TIMESTAMP'
}

export type PaymentMethodOwnerResourceUnion = TenantAccount | Person;

/** Possible values representing the payment method status. */
export enum PaymentMethodStatus {
  Deleted = 'DELETED',
  Processing = 'PROCESSING',
  ProcessingComplete = 'PROCESSING_COMPLETE',
  ProcessingError = 'PROCESSING_ERROR',
  Unverified = 'UNVERIFIED',
  VerificationFailed = 'VERIFICATION_FAILED',
  VerificationPending = 'VERIFICATION_PENDING',
  Verified = 'VERIFIED',
  Unknown = 'UNKNOWN'
}

/** Possible values representing the payment method type. */
export enum PaymentMethodType {
  CreditCard = 'CREDIT_CARD',
  PaymentBankUs = 'PAYMENT_BANK_US'
}

/** Ways in which lists of payments can be ordered upon return */
export type PaymentOrder = {
  /** The direction in which to order payments by the specified field */
  direction: OrderDirection,
  /** The field in which to order payments */
  field: PaymentOrderField,
};

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum PaymentOrderField {
  Timestamp = 'TIMESTAMP'
}

/** 
 * The PaymentRequest defines an instance of a payment requested by the merchant /
 * legal entity. The payment request can have many communications, payments and refunds.
 */
export type PaymentRequest = {
   __typename?: 'PaymentRequest',
  /** The amount requested */
  amount?: Maybe<Scalars['Int']>,
  /** A list of the communications sent to the payee against this request */
  communications: Array<Maybe<PaymentRequestCommunication>>,
  /** The time the payment request was created */
  createdAt: Scalars['DateTime'],
  /** The time the payment request was last modified */
  modifiedTimestamp: Scalars['DateTime'],
  /** The Id for the payment request */
  id: Scalars['String'],
  /** The Id for the invoice */
  invoiceId?: Maybe<Scalars['String']>,
  /** The link to the invoice pdf file. */
  invoiceLink?: Maybe<Scalars['String']>,
  /** The owner of the payment request. */
  owner: Owner,
  /** The reference number of the payment request, must be unique for the tenant */
  referenceNumber?: Maybe<Scalars['String']>,
  /** The current status of the payment request. Pending will be set while the payment is being processed */
  status?: Maybe<PaymentRequestStatus>,
  /** The current reason for the status */
  statusReason?: Maybe<Scalars['String']>,
  /** The list of payments made against this request */
  payments: Array<Maybe<Payment>>,
  /** The creator of the payment requests */
  createdBy?: Maybe<Scalars['String']>,
  /** Level 2/Level 3 processing data */
  l2l3Data?: Maybe<L2L3Data>,
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
};

/** The Payment Request Communication represents a single attempt to ask for a payment */
export type PaymentRequestCommunication = {
   __typename?: 'PaymentRequestCommunication',
  communicationType: CommunicationType,
  /** The email address to send the communication */
  email?: Maybe<Scalars['String']>,
  id: Scalars['String'],
  /** The phone number to send the communication */
  phoneNumber?: Maybe<Scalars['String']>,
  /** The time the communication request was made */
  requestTimestamp: Scalars['DateTime'],
  /** The time the communication request was sent */
  sentTimestamp?: Maybe<Scalars['DateTime']>,
  /** The owner of the payment. */
  owner: Owner,
};

/** A list of payment requests associated with the merchant. */
export type PaymentRequestConnection = {
   __typename?: 'PaymentRequestConnection',
  /** A list of edges. */
  edges: Array<Maybe<PaymentRequestEdge>>,
  /** The item at the end of each edge in the edges collection. */
  nodes: Array<Maybe<PaymentRequest>>,
  /** Information to aid in pagination. */
  pageInfo: PageInfo,
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'],
};

/** 
 * An edge in a connection. Think of the edge as the connection between two nodes.
 *   Its tightly coupled to the filter and order by applied to the connection, any
 * changes to the filter or order by will invalidate the edge
 */
export type PaymentRequestEdge = {
   __typename?: 'PaymentRequestEdge',
  /** A cursor for use in pagination. */
  cursor: Scalars['String'],
  /** The item at the end of the edge. */
  node: PaymentRequest,
};

/** The Payment Request Info is a condensed form of the Payment Request. */
export type PaymentRequestInfo = {
   __typename?: 'PaymentRequestInfo',
  amount: Scalars['Int'],
  currency: CurrencyType,
  invoiceLink?: Maybe<Scalars['String']>,
  referenceNumber: Scalars['String'],
  paymentRequestId: Scalars['String'],
  status: PaymentRequestStatus,
  statusReason?: Maybe<Scalars['String']>,
  merchantName: Scalars['String'],
  merchantStatementDescription: Scalars['String'],
  refundPolicy: Scalars['String'],
  tenantId: Scalars['ID'],
  allowedPaymentTypes?: Maybe<Array<PaymentType>>,
  /** Supported payment methods enabled for the tenant. */
  supportedPaymentMethods?: Maybe<Array<PaymentMethodType>>,
};

/** Ways in which lists of payment requests can be ordered upon return */
export type PaymentRequestOrder = {
  /** The direction in which to order payment requests by the specified field */
  direction: OrderDirection,
  /** The field in which to order payment requests */
  field: PaymentRequestOrderField,
};

/** Properties by which payment requests connections can be ordered. */
export enum PaymentRequestOrderField {
  Timestamp = 'TIMESTAMP'
}

/** Possible statuses for the payment request. */
export enum PaymentRequestStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  PendingAuthorization = 'PENDING_AUTHORIZATION',
  FullyRefunded = 'FULLY_REFUNDED',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  RefundFailed = 'REFUND_FAILED',
  RefundPending = 'REFUND_PENDING',
  Unpaid = 'UNPAID',
  Unknown = 'UNKNOWN',
  Closed = 'CLOSED'
}

/** Details on when funds from charges are available, and when they are paid out to an external account. */
export type PaymentSchedule = {
   __typename?: 'PaymentSchedule',
  interval?: Maybe<PayoutInterval>,
};

export type PaymentSettings = {
   __typename?: 'PaymentSettings',
  /** The refund policy */
  refundPolicy?: Maybe<Scalars['String']>,
  /** The description to appear on statements */
  statementDescription?: Maybe<Scalars['String']>,
};

/** Possible values representing the state of the payment. */
export enum PaymentStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  PendingAuthorization = 'PENDING_AUTHORIZATION',
  Unknown = 'UNKNOWN'
}

/** Possible values representing the type of the payment. */
export enum PaymentType {
  CardPayment = 'CARD_PAYMENT',
  EcheckPayment = 'ECHECK_PAYMENT'
}

/** Value describing how frequently funds will be paid out. */
export enum PayoutInterval {
  Daily = 'DAILY',
  Manual = 'MANUAL',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Unknown = 'UNKNOWN'
}

export type PayoutSettings = {
   __typename?: 'PayoutSettings',
  /** The text that appears on the bank account statement for payouts. */
  statementDescription?: Maybe<Scalars['String']>,
  /** The current status of the payout setting processing or processed */
  status: AccountPayoutsSettingsStatus,
  /** Details on when funds from charges are available, and when they are paid out to an external account. */
  schedule?: Maybe<PaymentSchedule>,
  /** The currency for the payouts */
  currency?: Maybe<CurrencyType>,
  /** The type of bank account to use for payouts */
  accountType: BankAccountType,
  /** The last four digits of the account */
  accountLastFour?: Maybe<Scalars['String']>,
};

export type Person = {
   __typename?: 'Person',
  /** Unique identifier for the object */
  id: Scalars['ID'],
  /** The person’s address. */
  address?: Maybe<Address>,
  createdAt?: Maybe<Scalars['DateTime']>,
  createdBy?: Maybe<Scalars['String']>,
  /** The person’s email address. */
  email?: Maybe<Scalars['String']>,
  /** The person’s first name. */
  firstName?: Maybe<Scalars['String']>,
  /** The person’s last name. */
  lastName?: Maybe<Scalars['String']>,
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
  phone?: Maybe<Phone>,
  /** Describes the person’s relationship to the account. */
  relationship?: Maybe<AccountRelationship>,
  /** Information about the requirements for the individual, including what information needs to be collected, and by when. */
  requirements?: Maybe<AccountRequirements>,
  /** The owner of the person record. */
  owner: Owner,
  /** The person’s payer account details. */
  payerProfile?: Maybe<PayerProfile>,
  /** The timestamp when the person was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>,
  /** The user identifier who last updated the person */
  updatedBy?: Maybe<Scalars['String']>,
  /** The persons’s verification status. */
  verification?: Maybe<AccountPersonalVerification>,
  account: TenantAccount,
};

export type Phone = {
   __typename?: 'Phone',
  countryCode?: Maybe<Scalars['String']>,
  phoneNumber?: Maybe<Scalars['String']>,
  number?: Maybe<Scalars['String']>,
};

/** Input for a phone number */
export type PhoneInputType = {
  /** the phone country code */
  countryCode: Scalars['String'],
  /** the phone number */
  number: Scalars['String'],
};

/** Input data for processing a payment request */
export type ProcessPaymentRequestInput = {
  /** The payment request reference number */
  referenceNumber: Scalars['String'],
  /** The payment processing token */
  paymentToken: Scalars['String'],
  /** The payment request id */
  paymentRequestId: Scalars['String'],
  /** The tenant id */
  tenantId: Scalars['String'],
  /** The amount the user expects to pay */
  expectedPaymentAmount: Scalars['Int'],
  /** The payers postal code */
  payerPostalCode: Scalars['String'],
  /** The payers country */
  payerCountry: Scalars['String'],
  /** The payers email address */
  payerEmailAddress: Scalars['String'],
  /** The payers full name */
  payerFullName: Scalars['String'],
  /** The payers phone country code */
  payerPhoneCountryCode?: Maybe<Scalars['String']>,
  /** The payers phone number */
  payerPhoneNumber?: Maybe<Scalars['String']>,
};

/** Status response for mutation for upserting a payment request. */
export type ProcessPaymentStatus = {
   __typename?: 'ProcessPaymentStatus',
  code: MutationStatusCode,
  message?: Maybe<Scalars['String']>,
  error?: Maybe<Scalars['String']>,
};

/** Input data for processing a refund */
export type ProcessRefundInput = {
  /** The payment id */
  paymentId: Scalars['String'],
  /** The reason for the refund */
  refundReason: Scalars['String'],
  /** The amount of the refund, if partial. Otherwise null. */
  amount?: Maybe<Scalars['Int']>,
};

/** Status response for mutation for creating a refund. */
export type ProcessRefundStatus = {
   __typename?: 'ProcessRefundStatus',
  code: MutationStatusCode,
  message?: Maybe<Scalars['String']>,
  error?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['String']>,
};

export type Query = {
   __typename?: 'Query',
  /** 
 * [NOT ACCESSIBLE BY API] Get the disputes within the filter criteria.
   *       Key Information:
   *       first = the number of items from the start cursor
   *       last = no currently supported
   *       dateRange: when using a date range the start and end dates must be in this format - "2020-01-01T00:00:00Z"
   *       edges = contain the link between 2 nodes and will only work if the filter and ordering remain consistent
   *       orderBy = if missing will default to the created time descending
 */
  disputes: DisputeConnection,
  payerTransactions: PayerTransactionConnection,
  paymentMethods: PaymentMethodConnection,
  /** Get the payment request from the url token included in the email or sms communication */
  paymentRequestFromUrlToken: PaymentRequestInfo,
  /** 
 * Get the  payment requests within the filter criteria.
   *     Key Information:
   *     first = the number of items from the start cursor
   *     last = no currently supported
   *     dateRange: when using a date range the start and end dates must be in this format - "2020-01-01T00:00:00Z"
   *     edges = contain the link between 2 nodes and will only work if the filter and ordering remain consistent
   *     orderBy = if missing will default to the created time descending
   * 
   *     An example for a query will look like:
   * 
   *     query {
   *       paymentRequests (first:10, last: 0, orderBy: { direction: DESC, field:TIMESTAMP }) {
   *           pageInfo {
   *             endCursor
   *             hasNextPage
   *             hasPreviousPage
   *             startCursor
   *           }
   *           totalCount
   *           nodes {
   *             amount
   *             communications {
   *               communicationType
   *               email
   *               phoneNumber
   *               requestTimestamp
   *             }
   *             createdAt
   *             id
   *             invoiceLink
   *             referenceNumber
   *             status
   *             statusReason
   *           }
   *           edges {
   *             cursor
   *             node {
   *               id
   *             }
   *           }
   *         }
   *       }
 */
  paymentRequests: PaymentRequestConnection,
  payments: PaymentConnection,
  /** [NOT ACCESSIBLE BY API] Get the person from their email address */
  person: Person,
  /** [NOT ACCESSIBLE BY API] Get a list of people */
  persons: Array<Person>,
  refunds: RefundConnection,
  /** Get the details from the contextual tenant account */
  account: TenantAccount,
  /** Get a connection to the transaction records within the filter criteria */
  transactionRecords: TransactionRecordConnection,
  viewer: Viewer,
};


export type QueryDisputesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  orderBy: DisputeOrder,
  dateRangeType?: Maybe<DisputeDateRangeType>,
  startDate?: Maybe<Scalars['DateTime']>,
  endDate?: Maybe<Scalars['DateTime']>,
  status?: Maybe<DisputeStatus>
};


export type QueryPayerTransactionsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  orderBy: PayerTransactionOrder,
  dateRangeType?: Maybe<PaymentDateRangeType>,
  startDate?: Maybe<Scalars['DateTime']>,
  endDate?: Maybe<Scalars['DateTime']>,
  status?: Maybe<Array<PaymentRequestStatus>>
};


export type QueryPaymentMethodsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  orderBy?: Maybe<PaymentMethodOrder>,
  resourceId?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['String']>
};


export type QueryPaymentRequestFromUrlTokenArgs = {
  urlToken: Scalars['String']
};


export type QueryPaymentRequestsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  orderBy: PaymentRequestOrder,
  queryString?: Maybe<Scalars['String']>,
  dateRangeType?: Maybe<PaymentDateRangeType>,
  startDate?: Maybe<Scalars['DateTime']>,
  endDate?: Maybe<Scalars['DateTime']>,
  status?: Maybe<PaymentRequestStatus>
};


export type QueryPaymentsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  orderBy?: Maybe<PaymentOrder>,
  id?: Maybe<Scalars['String']>,
  queryString?: Maybe<Scalars['String']>
};


export type QueryPersonArgs = {
  email: Scalars['String']
};


export type QueryRefundsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  orderBy?: Maybe<RefundOrder>,
  id?: Maybe<Scalars['String']>,
  paymentId?: Maybe<Scalars['String']>
};


export type QueryTransactionRecordsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  orderBy: TransactionRecordOrder,
  startDate?: Maybe<Scalars['DateTime']>,
  endDate?: Maybe<Scalars['DateTime']>
};

export type Refund = {
   __typename?: 'Refund',
  /** The amount to be refunded */
  amount?: Maybe<Scalars['Int']>,
  /** The time the refund was attempted */
  attemptTimestamp?: Maybe<Scalars['DateTime']>,
  /** The time the refund was created */
  createTime?: Maybe<Scalars['DateTime']>,
  /** The currency used for the refund */
  currency?: Maybe<Scalars['String']>,
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
  /** The reason why the refund failed */
  failureReason?: Maybe<Scalars['String']>,
  /** The Id for the refund */
  id?: Maybe<Scalars['String']>,
  /** The owner */
  owner: Owner,
  /** The payment */
  payment: Payment,
  /** The reason why the refund is pending */
  pendingReason?: Maybe<Scalars['String']>,
  /** The reason the for the refund */
  refundReason?: Maybe<Scalars['String']>,
  /** The current state of the refund */
  status?: Maybe<RefundStatus>,
};

/** A list of refunds associated with the merchant. */
export type RefundConnection = {
   __typename?: 'RefundConnection',
  /** A list of edges. */
  edges: Array<Maybe<RefundEdge>>,
  /** The item at the end of each edge in the edges collection. */
  nodes: Array<Maybe<Refund>>,
  /** Information to aid in pagination. */
  pageInfo: PageInfo,
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'],
};

/** 
 * An edge in a connection. Think of the edge as the connection between two nodes.
 *   Its tightly coupled to the filter and order by applied to the connection, any
 * changes to the filter or order by will invalidate the edge
 */
export type RefundEdge = {
   __typename?: 'RefundEdge',
  /** A cursor for use in pagination. */
  cursor: Scalars['String'],
  /** The item at the end of the edge. */
  node: Refund,
};

/** Ways in which lists of payments can be ordered upon return */
export type RefundOrder = {
  /** The direction in which to order payments by the specified field */
  direction: OrderDirection,
  /** The field in which to order payments */
  field: RefundOrderField,
};

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum RefundOrderField {
  Timestamp = 'TIMESTAMP'
}

/** Possible values for the refund status */
export enum RefundStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

/** Input data for Level 2/Level 3 data processing. */
export type RiskMetadataPaymentInput = {
  /** The address of the payer. */
  address: AddressInputType,
  /** The phone number of the payer. */
  phone: PhoneInputType,
  /** The line items that were paid for, if any. */
  lineItems: Array<Maybe<RiskMetadataPaymentLineItemInput>>,
  /** The sales order number or other id associated with this payment. */
  salesOrderNumber?: Maybe<Scalars['String']>,
};

/** Input data for Level 2/Level 3 data processing. */
export type RiskMetadataPaymentLineItemInput = {
  /** The description of the line item. */
  description: Scalars['String'],
  /** The price of the line item in the currency lowest denomination. */
  price: Scalars['Int'],
  /** The currency of the line item price. */
  currency: CurrencyType,
  /** The quantity of the line item. */
  quantity: Scalars['Int'],
};

/** Input data for sending account verification document tokens. */
export type SubmitVerificationInput = {
  documentTokens: Array<DocumentTokenInput>,
};

/** Status response for mutation for upserting a tenant account. */
export type SubmitVerificationStatus = {
   __typename?: 'SubmitVerificationStatus',
  code: MutationStatusCode,
  message?: Maybe<Scalars['String']>,
  error?: Maybe<Scalars['String']>,
};

export type TenantAccount = {
   __typename?: 'TenantAccount',
  /** the balance based on the currency */
  balances?: Maybe<AccountBalances>,
  /** the business profile for the tenant account */
  businessProfile?: Maybe<BusinessProfile>,
  /** the type of business */
  businessType?: Maybe<BusinessType>,
  /** 
 * The set of capabilities for this account and their associated states. Keys are
   * names of capabilities. Values may be ACTIVE, INACTIVE, or PENDING
 */
  capabilities?: Maybe<TenantAccountCapabilities>,
  /** 
 * Information about the company or business. This field is null unless
   * businessType is set to COMPANY, GOVT_ENTITY, or NON_PROFIT.
 */
  company?: Maybe<Company>,
  /** The timestamp when the tenant account was created */
  createdAt?: Maybe<Scalars['DateTime']>,
  /** The name of the user that created the tenant account */
  createdBy?: Maybe<Scalars['String']>,
  /** The account’s country */
  country?: Maybe<Scalars['String']>,
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
  /** Three-letter ISO currency code representing the default currency for the account. */
  defaultCurrency?: Maybe<CurrencyType>,
  /** The primary account holder’s email address */
  email?: Maybe<Scalars['String']>,
  /** Unique identifier for the object */
  id: Scalars['ID'],
  /** The owner of the tenant account. */
  owner: Owner,
  /** The ids of the payment facilitator. */
  payfac?: Maybe<PayFacIds>,
  /** Information about the requirements for the account, including what information needs to be collected, and by when. */
  requirements?: Maybe<AccountRequirements>,
  /** Options for customizing how the account functions. */
  settings?: Maybe<AccountSettings>,
  /** Details on acceptance of the EZPay Services Agreement. */
  tosAcceptance?: Maybe<TosAcceptance>,
  /** The timestamp when the tenant account document was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>,
  /** The user that last updated the tenant account document */
  updatedBy?: Maybe<Scalars['String']>,
  /** Url of the fee schedule */
  feeSchedule?: Maybe<Scalars['String']>,
  /** A list of the transaction statements for the account  */
  statements?: Maybe<Array<TransactionStatement>>,
  /** Any errors that associated with this tenant account */
  errors?: Maybe<Array<Scalars['String']>>,
  /** The Aptean ERP or service that owns the tenant */
  owningProduct?: Maybe<ApteanProduct>,
  /** The tenants payer account details. */
  payerProfile?: Maybe<PayerProfile>,
};

export type TenantAccountCapabilities = {
   __typename?: 'TenantAccountCapabilities',
  cardPayments: CapabilityStatus,
  achPayments: CapabilityStatus,
  accountPayouts: CapabilityStatus,
};

export type Token = {
   __typename?: 'Token',
  /** The token id. */
  id: Scalars['String'],
  /** IP address of the client that generated the token. */
  clientIp?: Maybe<Scalars['String']>,
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: Scalars['Float'],
  /** Time at which the object was created. */
  createTime: Scalars['DateTime'],
  /** Indicates if the token is for the live environment. */
  livemode: Scalars['Boolean'],
  /** The payment method type */
  type: Scalars['String'],
  /** Indicates if the token has been used. */
  used: Scalars['Boolean'],
};

export type TosAcceptance = {
   __typename?: 'TosAcceptance',
  /** The timestamp marking when the EZPay Services Agreement was accepted by the primary account holder. */
  date?: Maybe<Scalars['DateTime']>,
  /** The IP address from which the EZPay Agreement was accepted by the account representative. */
  ip?: Maybe<Scalars['String']>,
  /** The user agent of the browser from which the EZPay Agreement was accepted by the account representative. */
  userAgent?: Maybe<Scalars['String']>,
};

export type TransactionRecord = {
   __typename?: 'TransactionRecord',
  createdAt: Scalars['DateTime'],
  /** The currency of the transaction */
  currency: CurrencyType,
  /** The fee amount applied to the transaction */
  feeAmount: Scalars['Int'],
  /** The gross amount associated with the transaction */
  grossAmount: Scalars['Int'],
  /** The id of the transaction */
  id: Scalars['String'],
  /** The net amount associated with the transaction (gross - fee = net) */
  netAmount: Scalars['Int'],
  /** The type of transaction */
  transactionType: TransactionRecordType,
  /** The owner of the transaction. */
  owner: Owner,
};

/** A list of transaction records. */
export type TransactionRecordConnection = {
   __typename?: 'TransactionRecordConnection',
  /** A list of edges. */
  edges: Array<Maybe<TransactionRecordEdge>>,
  /** The item at the end of each edge in the edges collection. */
  nodes: Array<Maybe<TransactionRecord>>,
  /** Information to aid in pagination. */
  pageInfo: PageInfo,
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'],
};

/** An edge in a connection. */
export type TransactionRecordEdge = {
   __typename?: 'TransactionRecordEdge',
  /** A cursor for use in pagination. */
  cursor: Scalars['String'],
  /** The item at the end of the edge. */
  node: TransactionRecord,
};

/** Ways in which lists of transaction records can be ordered upon return */
export type TransactionRecordOrder = {
  /** The direction in which to order transaction records by the specified field */
  direction: OrderDirection,
  /** The field in which to order transaction records */
  field: TransactionRecordOrderField,
};

/** The field to use when sorting transaction records */
export enum TransactionRecordOrderField {
  Timestamp = 'TIMESTAMP'
}

/** The type of transaction record. */
export enum TransactionRecordType {
  AppFee = 'APP_FEE',
  MerchantPayment = 'MERCHANT_PAYMENT',
  Adjustment = 'ADJUSTMENT',
  AppFeeChargeback = 'APP_FEE_CHARGEBACK',
  AppFeeChargebackReversal = 'APP_FEE_CHARGEBACK_REVERSAL',
  AppFeeRefund = 'APP_FEE_REFUND',
  MerchantChargeback = 'MERCHANT_CHARGEBACK',
  MerchantChargebackFee = 'MERCHANT_CHARGEBACK_FEE',
  MerchantChargebackReversal = 'MERCHANT_CHARGEBACK_REVERSAL',
  MerchantPaymentRefund = 'MERCHANT_PAYMENT_REFUND',
  Payout = 'PAYOUT',
  PayoutReturn = 'PAYOUT_RETURN',
  Recovery = 'RECOVERY',
  RecoveryReturn = 'RECOVERY_RETURN',
  Unknown = 'UNKNOWN'
}

export type TransactionStatement = {
   __typename?: 'TransactionStatement',
  /** The date the statement was created */
  createdAt: Scalars['DateTime'],
  /** The start date for the statements transactions */
  startTime: Scalars['DateTime'],
  /** The end date for the statements transactions */
  endTime: Scalars['DateTime'],
  /** The URL to download the statements */
  url: Scalars['String'],
};

/** Input data for conceding a dispute */
export type UpdateDisputeInput = {
  /** The dispute id */
  id: Scalars['ID'],
  /** Text explaining why they are challenging the dispute */
  explanation: Scalars['String'],
  /** The document ids uploaded to wepay. */
  documents: Array<Scalars['String']>,
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
};

/** Input data for updating a payment method */
export type UpdatePaymentMethodInput = {
  /** The payment method id */
  paymentMethodId: Scalars['ID'],
  /** The id of the person or tenant to which payment method is attached. */
  resourceId: Scalars['String'],
  /** Indicates if this payment method is the default for the payer. */
  isDefault: Scalars['Boolean'],
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
};

/** Status response for mutation for updating a payment method. */
export type UpdatePaymentMethodStatus = {
   __typename?: 'UpdatePaymentMethodStatus',
  code: MutationStatusCode,
  message?: Maybe<Scalars['String']>,
  error?: Maybe<Scalars['String']>,
  paymentMethod?: Maybe<PaymentMethod>,
};


/** Input data for uploading files. */
export type UploadInput = {
  file: Scalars['Upload'],
};

/** Input data for upserting a person / user for a payer account */
export type UpsertPayerInput = {
  /** the email address of the user being updated or created. Once set the email can not be changed. */
  email?: Maybe<Scalars['String']>,
  /** the first name of the user */
  firstName?: Maybe<Scalars['String']>,
  /** the users id */
  id?: Maybe<Scalars['ID']>,
  /** the last name of the user */
  lastName?: Maybe<Scalars['String']>,
  /** the phone country code */
  phoneCountryCode?: Maybe<Scalars['String']>,
  /** the phone number */
  phoneNumber?: Maybe<Scalars['String']>,
};

/** Input data for upserting a payment request */
export type UpsertPaymentRequestInput = {
  /** The payment request id */
  id?: Maybe<Scalars['ID']>,
  /** Merchant-specific reference number. Required to create a payment request. */
  referenceNumber?: Maybe<Scalars['String']>,
  /** Method of payment request. Either email and / or sms. */
  type?: Maybe<CommunicationType>,
  /** (Required) The email address of the payer, destination for the email communication. Required to create a payment request. */
  email?: Maybe<Scalars['String']>,
  /** The phone number of the payer, destination for the sms communication. Format is E.164 format, for example +14155552671 */
  phoneNumber?: Maybe<Scalars['String']>,
  /** 
 * (Required) The amount of money to request, currency is defined in the tenant
   * account. Required to create a payment request.
 */
  amount?: Maybe<Scalars['Int']>,
  /** The status of the payment request, can only set to CLOSED for existing payment requests */
  status?: Maybe<PaymentRequestStatus>,
  /** The reason the status is changing, required if updating the status to CLOSED */
  statusReason?: Maybe<Scalars['String']>,
  /** Whether to send an email or sms when updating the payment request. only applicable when updating an existing request */
  sendCommunication?: Maybe<Scalars['Boolean']>,
  /** Level 2/Level 3 data. */
  l2l3Data?: Maybe<L2L3DataInput>,
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
  /** The reference id of the uploaded invoice */
  invoiceRef?: Maybe<Scalars['String']>,
};

/** Input data for upserting a payment request with no invoice */
export type UpsertPaymentRequestNoInvoiceInput = {
  /** The payment request id */
  id?: Maybe<Scalars['ID']>,
  /** Merchant-specific reference number. Required to create a payment request. */
  referenceNumber?: Maybe<Scalars['String']>,
  /** Method of payment request. Either email and / or sms. */
  type?: Maybe<CommunicationType>,
  /** (Required) The email address of the payer, destination for the email communication. Required to create a payment request. */
  email?: Maybe<Scalars['String']>,
  /** The phone number of the payer, destination for the sms communication. Format is E.164 format, for example +14155552671 */
  phoneNumber?: Maybe<Scalars['String']>,
  /** 
 * (Required) The amount of money to request, currency is defined in the tenant
   * account. Required to create a payment request.
 */
  amount?: Maybe<Scalars['Int']>,
  /** The status of the payment request, can only set to CLOSED for existing payment requests */
  status?: Maybe<PaymentRequestStatus>,
  /** The reason the status is changing, required if updating the status to CLOSED */
  statusReason?: Maybe<Scalars['String']>,
  /** Whether to send an email or sms when updating the payment request. only applicable when updating an existing request */
  sendCommunication?: Maybe<Scalars['Boolean']>,
  /** Level 2/Level 3 data. */
  l2l3Data?: Maybe<L2L3DataInput>,
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
  /** Order line items */
  orderLineItems?: Maybe<Array<OrderLineItemInput>>,
};

/** Status response for mutation for upserting a payment request. */
export type UpsertPaymentRequestStatus = {
   __typename?: 'UpsertPaymentRequestStatus',
  code: MutationStatusCode,
  message?: Maybe<Scalars['String']>,
  error?: Maybe<Scalars['String']>,
  paymentRequestId?: Maybe<Scalars['ID']>,
  paymentUrl?: Maybe<Scalars['String']>,
};

/** Input data for updating the payout schedule frequency. */
export type UpsertPayoutFrequencyInput = {
  interval: PayoutInterval,
};

/** Status response for mutation for upserting a payout frequency schedule. */
export type UpsertPayoutFrequencyStatus = {
   __typename?: 'UpsertPayoutFrequencyStatus',
  code: MutationStatusCode,
  message: Scalars['String'],
  error?: Maybe<Scalars['String']>,
};

/** Input data for creating a payout settings using a token. */
export type UpsertPayoutSettingsInput = {
  token: Scalars['String'],
  /** Input data for updating the payout schedule frequency. */
  interval?: Maybe<PayoutInterval>,
};

/** Status response for mutation for upserting a payout setting. */
export type UpsertPayoutSettingsStatus = {
   __typename?: 'UpsertPayoutSettingsStatus',
  code: MutationStatusCode,
  message: Scalars['String'],
  error?: Maybe<Scalars['String']>,
};

/** Input data for upserting a person */
export type UpsertPersonInput = {
  /** the users first name */
  firstName?: Maybe<Scalars['String']>,
  /** the users id */
  id?: Maybe<Scalars['ID']>,
  /** the users email address */
  email: Scalars['String'],
  /** the users last name */
  lastName?: Maybe<Scalars['String']>,
  /** the users role */
  role?: Maybe<AppRole>,
  /** whether to flag the user as deleted */
  deleted?: Maybe<Scalars['Boolean']>,
};

/** Status response mutation for for upserting a person */
export type UpsertPersonStatus = {
   __typename?: 'UpsertPersonStatus',
  code: MutationStatusCode,
  message: Scalars['String'],
  error?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['String']>,
  person?: Maybe<Person>,
};

/** Input data for creating a tenant account. */
export type UpsertTenantAccountInput = {
  country?: Maybe<CountryCode>,
  token?: Maybe<Scalars['String']>,
  primaryAccountHolderEmail?: Maybe<Scalars['String']>,
  tosAcceptanceTime?: Maybe<Scalars['DateTime']>,
  tosAcceptanceUserAgent?: Maybe<Scalars['String']>,
  accountName?: Maybe<Scalars['String']>,
  accountDescription?: Maybe<Scalars['String']>,
  statementDescription?: Maybe<Scalars['String']>,
  refundPolicy?: Maybe<Scalars['String']>,
  businessUrl?: Maybe<Scalars['String']>,
  supportEmail?: Maybe<Scalars['String']>,
};

/** Status response for mutation for upserting a tenant account. */
export type UpsertTenantAccountStatus = {
   __typename?: 'UpsertTenantAccountStatus',
  code: MutationStatusCode,
  message?: Maybe<Scalars['String']>,
  error?: Maybe<Scalars['String']>,
};

/** Input data for verifying payment method microdeposits */
export type VerifyPaymentMethodInput = {
  paymentMethodId: Scalars['ID'],
  microDeposits: Array<Scalars['Int']>,
  /** 
 * Set of key-value pairs that you can attach to an object. This can be useful
   * for storing additional information about the object in a structured format.
 */
  customData?: Maybe<Scalars['JSONObject']>,
};

/** Status response mutation for for verifying payment methods */
export type VerifyPaymentMethodStatus = {
   __typename?: 'VerifyPaymentMethodStatus',
  code: MutationStatusCode,
  message: Scalars['String'],
  error?: Maybe<Scalars['String']>,
  paymentMethod?: Maybe<PaymentMethod>,
};

export type Viewer = {
   __typename?: 'Viewer',
  currentUser?: Maybe<Person>,
};

export type UpdateDisputeMutationVariables = {
  input: UpdateDisputeInput
};


export type UpdateDisputeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateDispute'>
);

export type ConcedeDisputeMutationVariables = {
  input: ConcedeDisputeInput
};


export type ConcedeDisputeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'concedeDispute'>
);

export type DeletePersonMutationVariables = {
  input: DeletePersonInput
};


export type DeletePersonMutation = (
  { __typename?: 'Mutation' }
  & { deletePerson: (
    { __typename?: 'DeletePersonStatus' }
    & Pick<DeletePersonStatus, 'code' | 'message' | 'error'>
  ) }
);

export type CreateRefundMutationVariables = {
  input: CreateRefundInput
};


export type CreateRefundMutation = (
  { __typename?: 'Mutation' }
  & { createRefund: (
    { __typename?: 'CreateRefundStatus' }
    & Pick<CreateRefundStatus, 'code' | 'error' | 'message'>
  ) }
);

export type SubmitVerificationMutationVariables = {
  input: SubmitVerificationInput
};


export type SubmitVerificationMutation = (
  { __typename?: 'Mutation' }
  & { submitVerification: (
    { __typename?: 'SubmitVerificationStatus' }
    & Pick<SubmitVerificationStatus, 'code' | 'message' | 'error'>
  ) }
);

export type UploadDocumentMutationVariables = {
  input: UploadInput
};


export type UploadDocumentMutation = (
  { __typename?: 'Mutation' }
  & { upload: (
    { __typename?: 'MediaStatus' }
    & Pick<MediaStatus, 'uniqueId'>
  ) }
);

export type UpsertBusinessUrlMutationVariables = {
  input: UpsertTenantAccountInput
};


export type UpsertBusinessUrlMutation = (
  { __typename?: 'Mutation' }
  & { upsertTenantAccount: (
    { __typename?: 'UpsertTenantAccountStatus' }
    & Pick<UpsertTenantAccountStatus, 'code' | 'message' | 'error'>
  ) }
);

export type UpsertPaymentRequestMutationVariables = {
  input: UpsertPaymentRequestInput
};


export type UpsertPaymentRequestMutation = (
  { __typename?: 'Mutation' }
  & { upsertPaymentRequest: (
    { __typename?: 'UpsertPaymentRequestStatus' }
    & Pick<UpsertPaymentRequestStatus, 'code' | 'message' | 'paymentRequestId' | 'error'>
  ) }
);

export type UpsertPayoutFrequencyMutationVariables = {
  input: UpsertPayoutFrequencyInput
};


export type UpsertPayoutFrequencyMutation = (
  { __typename?: 'Mutation' }
  & { upsertPayoutFrequency: (
    { __typename?: 'UpsertPayoutFrequencyStatus' }
    & Pick<UpsertPayoutFrequencyStatus, 'code' | 'message'>
  ) }
);

export type UpsertPayoutSettingsMutationVariables = {
  input: UpsertPayoutSettingsInput
};


export type UpsertPayoutSettingsMutation = (
  { __typename?: 'Mutation' }
  & { upsertPayoutSettings: (
    { __typename?: 'UpsertPayoutSettingsStatus' }
    & Pick<UpsertPayoutSettingsStatus, 'code' | 'message'>
  ) }
);

export type UpsertPersonMutationVariables = {
  input: UpsertPersonInput
};


export type UpsertPersonMutation = (
  { __typename?: 'Mutation' }
  & { upsertPerson: (
    { __typename?: 'UpsertPersonStatus' }
    & Pick<UpsertPersonStatus, 'code' | 'message' | 'error'>
  ) }
);

export type UpsertRefundPolicyMutationVariables = {
  input: UpsertTenantAccountInput
};


export type UpsertRefundPolicyMutation = (
  { __typename?: 'Mutation' }
  & { upsertTenantAccount: (
    { __typename?: 'UpsertTenantAccountStatus' }
    & Pick<UpsertTenantAccountStatus, 'code' | 'message' | 'error'>
  ) }
);

export type UpsertStatementDescriptionMutationVariables = {
  input: UpsertTenantAccountInput
};


export type UpsertStatementDescriptionMutation = (
  { __typename?: 'Mutation' }
  & { upsertTenantAccount: (
    { __typename?: 'UpsertTenantAccountStatus' }
    & Pick<UpsertTenantAccountStatus, 'code' | 'message' | 'error'>
  ) }
);

export type UpsertSupportEmailMutationVariables = {
  input: UpsertTenantAccountInput
};


export type UpsertSupportEmailMutation = (
  { __typename?: 'Mutation' }
  & { upsertTenantAccount: (
    { __typename?: 'UpsertTenantAccountStatus' }
    & Pick<UpsertTenantAccountStatus, 'code' | 'message' | 'error'>
  ) }
);

export type UpsertTenantAccountMutationVariables = {
  input: UpsertTenantAccountInput
};


export type UpsertTenantAccountMutation = (
  { __typename?: 'Mutation' }
  & { upsertTenantAccount: (
    { __typename?: 'UpsertTenantAccountStatus' }
    & Pick<UpsertTenantAccountStatus, 'code' | 'message'>
  ) }
);

export type GetAdditionalVerifcationsQueryVariables = {};


export type GetAdditionalVerifcationsQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'TenantAccount' }
    & { requirements: Maybe<(
      { __typename?: 'AccountRequirements' }
      & Pick<AccountRequirements, 'currentDeadline' | 'currentlyDue' | 'disabledReason' | 'errors' | 'eventuallyDue' | 'pastDue' | 'pendingVerification'>
    )> }
  ) }
);

export type DisputesQueryVariables = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  orderBy: DisputeOrder
};


export type DisputesQuery = (
  { __typename?: 'Query' }
  & { disputes: (
    { __typename?: 'DisputeConnection' }
    & Pick<DisputeConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ), nodes: Array<Maybe<(
      { __typename?: 'Dispute' }
      & Pick<Dispute, 'amount' | 'status' | 'disputeType' | 'currency' | 'reason' | 'reasonMessage' | 'createdAt' | 'id' | 'resolution' | 'resolvedAt' | 'concedeMessage'>
      & { reasonDetails: Maybe<Array<(
        { __typename?: 'DisputeReasonDetail' }
        & Pick<DisputeReasonDetail, 'code' | 'message'>
      )>>, owner: Maybe<(
        { __typename?: 'Owner' }
        & Pick<Owner, 'paymentId' | 'tenantId'>
      )> }
    )>>, edges: Array<Maybe<(
      { __typename?: 'DisputeEdge' }
      & Pick<DisputeEdge, 'cursor'>
      & { node: (
        { __typename?: 'Dispute' }
        & Pick<Dispute, 'id'>
      ) }
    )>> }
  ) }
);

export type GetOwningProductQueryVariables = {};


export type GetOwningProductQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'TenantAccount' }
    & Pick<TenantAccount, 'owningProduct'>
  ) }
);

export type PaymentsQueryVariables = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  orderBy: PaymentOrder,
  queryString?: Maybe<Scalars['String']>
};


export type PaymentsQuery = (
  { __typename?: 'Query' }
  & { payments: (
    { __typename?: 'PaymentConnection' }
    & Pick<PaymentConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ), nodes: Array<Maybe<(
      { __typename?: 'Payment' }
      & Pick<Payment, 'id' | 'status' | 'pendingReason' | 'amount' | 'amountDisputed' | 'amountRefunded' | 'attemptTimestamp' | 'completedTimestamp' | 'createdAt' | 'cancelReason' | 'currency' | 'failureReason' | 'feeAmount' | 'immediateCapture' | 'initiatedBy'>
      & { owner: (
        { __typename?: 'Owner' }
        & Pick<Owner, 'tenantId' | 'paymentRequestId'>
      ), refunds: Array<Maybe<(
        { __typename?: 'Refund' }
        & Pick<Refund, 'amount' | 'attemptTimestamp' | 'currency' | 'id' | 'refundReason' | 'status' | 'createTime'>
        & { owner: (
          { __typename?: 'Owner' }
          & Pick<Owner, 'tenantId'>
        ), payment: (
          { __typename?: 'Payment' }
          & Pick<Payment, 'id' | 'amount'>
        ) }
      )>>, paymentRequest: Maybe<(
        { __typename?: 'PaymentRequest' }
        & Pick<PaymentRequest, 'amount' | 'createdAt' | 'createdBy' | 'id' | 'invoiceLink' | 'invoiceId' | 'referenceNumber' | 'status' | 'statusReason'>
        & { communications: Array<Maybe<(
          { __typename?: 'PaymentRequestCommunication' }
          & Pick<PaymentRequestCommunication, 'communicationType' | 'email' | 'phoneNumber' | 'requestTimestamp' | 'sentTimestamp'>
        )>>, payments: Array<Maybe<(
          { __typename?: 'Payment' }
          & Pick<Payment, 'id' | 'status' | 'amount' | 'amountRefunded'>
        )>>, owner: (
          { __typename?: 'Owner' }
          & Pick<Owner, 'paymentId' | 'tenantId' | 'disputeId'>
        ) }
      )> }
    )>>, edges: Array<Maybe<(
      { __typename?: 'PaymentEdge' }
      & Pick<PaymentEdge, 'cursor'>
      & { node: (
        { __typename?: 'Payment' }
        & Pick<Payment, 'id'>
      ) }
    )>> }
  ) }
);

export type PaymentRequestsQueryVariables = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  orderBy: PaymentRequestOrder,
  queryString?: Maybe<Scalars['String']>
};


export type PaymentRequestsQuery = (
  { __typename?: 'Query' }
  & { paymentRequests: (
    { __typename?: 'PaymentRequestConnection' }
    & Pick<PaymentRequestConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ), nodes: Array<Maybe<(
      { __typename?: 'PaymentRequest' }
      & Pick<PaymentRequest, 'amount' | 'createdAt' | 'createdBy' | 'id' | 'invoiceLink' | 'invoiceId' | 'referenceNumber' | 'status' | 'statusReason'>
      & { communications: Array<Maybe<(
        { __typename?: 'PaymentRequestCommunication' }
        & Pick<PaymentRequestCommunication, 'communicationType' | 'email' | 'phoneNumber' | 'requestTimestamp' | 'sentTimestamp'>
      )>>, payments: Array<Maybe<(
        { __typename?: 'Payment' }
        & Pick<Payment, 'id' | 'status' | 'amount' | 'amountRefunded'>
      )>>, owner: (
        { __typename?: 'Owner' }
        & Pick<Owner, 'paymentId' | 'tenantId' | 'disputeId'>
      ) }
    )>>, edges: Array<Maybe<(
      { __typename?: 'PaymentRequestEdge' }
      & Pick<PaymentRequestEdge, 'cursor'>
      & { node: (
        { __typename?: 'PaymentRequest' }
        & Pick<PaymentRequest, 'id'>
      ) }
    )>> }
  ) }
);

export type PayoutSettingsQueryVariables = {};


export type PayoutSettingsQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'TenantAccount' }
    & { settings: Maybe<(
      { __typename?: 'AccountSettings' }
      & { accountPayouts: Maybe<(
        { __typename?: 'PayoutSettings' }
        & Pick<PayoutSettings, 'accountType' | 'accountLastFour' | 'currency' | 'statementDescription' | 'status'>
        & { schedule: Maybe<(
          { __typename?: 'PaymentSchedule' }
          & Pick<PaymentSchedule, 'interval'>
        )> }
      )> }
    )> }
  ) }
);

export type GetPersonByEmailQueryVariables = {
  email: Scalars['String']
};


export type GetPersonByEmailQuery = (
  { __typename?: 'Query' }
  & { person: (
    { __typename?: 'Person' }
    & Pick<Person, 'id' | 'firstName' | 'lastName' | 'email'>
    & { relationship: Maybe<(
      { __typename?: 'AccountRelationship' }
      & Pick<AccountRelationship, 'role'>
    )>, owner: (
      { __typename?: 'Owner' }
      & Pick<Owner, 'tenantId'>
    ) }
  ) }
);

export type PersonsListQueryVariables = {};


export type PersonsListQuery = (
  { __typename?: 'Query' }
  & { persons: Array<(
    { __typename?: 'Person' }
    & Pick<Person, 'firstName' | 'lastName' | 'email' | 'updatedAt' | 'id' | 'createdAt'>
    & { relationship: Maybe<(
      { __typename?: 'AccountRelationship' }
      & Pick<AccountRelationship, 'owner' | 'primaryAccountHolder' | 'role' | 'involvement'>
    )>, verification: Maybe<(
      { __typename?: 'AccountPersonalVerification' }
      & Pick<AccountPersonalVerification, 'status'>
    )> }
  )> }
);

export type GetTenantAccountQueryVariables = {};


export type GetTenantAccountQuery = (
  { __typename?: 'Query' }
  & { account: (
    { __typename?: 'TenantAccount' }
    & Pick<TenantAccount, 'country' | 'createdAt' | 'id' | 'updatedAt' | 'email' | 'businessType' | 'defaultCurrency' | 'feeSchedule' | 'errors'>
    & { owner: (
      { __typename?: 'Owner' }
      & Pick<Owner, 'tenantId'>
    ), payfac: Maybe<(
      { __typename?: 'PayFacIds' }
      & { ids: Maybe<Array<(
        { __typename?: 'PayFacId' }
        & Pick<PayFacId, 'resourceId' | 'resourceType'>
      )>> }
    )>, capabilities: Maybe<(
      { __typename?: 'TenantAccountCapabilities' }
      & Pick<TenantAccountCapabilities, 'cardPayments' | 'achPayments' | 'accountPayouts'>
    )>, businessProfile: Maybe<(
      { __typename?: 'BusinessProfile' }
      & Pick<BusinessProfile, 'description' | 'name' | 'url' | 'supportEmail' | 'mcc'>
    )>, company: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'description' | 'name' | 'structure'>
      & { address: Maybe<(
        { __typename?: 'Address' }
        & Pick<Address, 'city' | 'country' | 'line1' | 'line2' | 'postalCode' | 'region'>
      )>, phone: Maybe<(
        { __typename?: 'Phone' }
        & Pick<Phone, 'countryCode' | 'number' | 'phoneNumber'>
      )>, verification: Maybe<(
        { __typename?: 'CompanyAccountVerification' }
        & Pick<CompanyAccountVerification, 'status'>
        & { additionalDocuments: Array<Maybe<(
          { __typename?: 'AccountVerificationDocument' }
          & Pick<AccountVerificationDocument, 'documentId' | 'rejectReason' | 'status' | 'type'>
        )>>, documents: Array<Maybe<(
          { __typename?: 'AccountVerificationDocument' }
          & Pick<AccountVerificationDocument, 'documentId' | 'rejectReason' | 'status' | 'type'>
        )>> }
      )> }
    )>, settings: Maybe<(
      { __typename?: 'AccountSettings' }
      & { cardPayments: Maybe<(
        { __typename?: 'PaymentSettings' }
        & Pick<PaymentSettings, 'refundPolicy' | 'statementDescription'>
      )>, achPayments: Maybe<(
        { __typename?: 'PaymentSettings' }
        & Pick<PaymentSettings, 'refundPolicy' | 'statementDescription'>
      )>, accountPayouts: Maybe<(
        { __typename?: 'PayoutSettings' }
        & Pick<PayoutSettings, 'statementDescription' | 'status' | 'currency' | 'accountType' | 'accountLastFour'>
        & { schedule: Maybe<(
          { __typename?: 'PaymentSchedule' }
          & Pick<PaymentSchedule, 'interval'>
        )> }
      )> }
    )>, statements: Maybe<Array<(
      { __typename?: 'TransactionStatement' }
      & Pick<TransactionStatement, 'createdAt' | 'startTime' | 'endTime' | 'url'>
    )>>, requirements: Maybe<(
      { __typename?: 'AccountRequirements' }
      & Pick<AccountRequirements, 'pastDue' | 'currentlyDue' | 'pendingVerification' | 'eventuallyDue'>
    )>, tosAcceptance: Maybe<(
      { __typename?: 'TosAcceptance' }
      & Pick<TosAcceptance, 'date'>
    )>, balances: Maybe<(
      { __typename?: 'AccountBalances' }
      & Pick<AccountBalances, 'balance' | 'incomingPending' | 'outgoingPending' | 'reserve' | 'updatedTimestamp'>
    )> }
  ) }
);

export type TransactionRecordsQueryVariables = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  orderBy: TransactionRecordOrder,
  startDate?: Maybe<Scalars['DateTime']>,
  endDate?: Maybe<Scalars['DateTime']>
};


export type TransactionRecordsQuery = (
  { __typename?: 'Query' }
  & { transactionRecords: (
    { __typename: 'TransactionRecordConnection' }
    & Pick<TransactionRecordConnection, 'totalCount'>
    & { pageInfo: (
      { __typename: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ), nodes: Array<Maybe<(
      { __typename: 'TransactionRecord' }
      & Pick<TransactionRecord, 'createdAt' | 'id' | 'transactionType' | 'grossAmount' | 'feeAmount' | 'netAmount'>
    )>>, edges: Array<Maybe<(
      { __typename: 'TransactionRecordEdge' }
      & Pick<TransactionRecordEdge, 'cursor'>
      & { node: (
        { __typename: 'TransactionRecord' }
        & Pick<TransactionRecord, 'id'>
      ) }
    )>> }
  ) }
);

export type GetViewerUserQueryVariables = {};


export type GetViewerUserQuery = (
  { __typename?: 'Query' }
  & { viewer: (
    { __typename?: 'Viewer' }
    & { currentUser: Maybe<(
      { __typename?: 'Person' }
      & Pick<Person, 'id' | 'firstName' | 'lastName' | 'email'>
      & { relationship: Maybe<(
        { __typename?: 'AccountRelationship' }
        & Pick<AccountRelationship, 'role'>
      )> }
    )> }
  ) }
);


export const UpdateDisputeDocument = gql`
    mutation updateDispute($input: UpdateDisputeInput!) {
  updateDispute(input: $input)
}
    `;
export type UpdateDisputeMutationFn = ApolloReactCommon.MutationFunction<UpdateDisputeMutation, UpdateDisputeMutationVariables>;
export type UpdateDisputeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateDisputeMutation, UpdateDisputeMutationVariables>, 'mutation'>;

    export const UpdateDisputeComponent = (props: UpdateDisputeComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateDisputeMutation, UpdateDisputeMutationVariables> mutation={UpdateDisputeDocument} {...props} />
    );
    
export type UpdateDisputeProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpdateDisputeMutation, UpdateDisputeMutationVariables> & TChildProps;
export function withUpdateDispute<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateDisputeMutation,
  UpdateDisputeMutationVariables,
  UpdateDisputeProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateDisputeMutation, UpdateDisputeMutationVariables, UpdateDisputeProps<TChildProps>>(UpdateDisputeDocument, {
      alias: 'updateDispute',
      ...operationOptions
    });
};
export type UpdateDisputeMutationResult = ApolloReactCommon.MutationResult<UpdateDisputeMutation>;
export type UpdateDisputeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDisputeMutation, UpdateDisputeMutationVariables>;
export const ConcedeDisputeDocument = gql`
    mutation concedeDispute($input: ConcedeDisputeInput!) {
  concedeDispute(input: $input)
}
    `;
export type ConcedeDisputeMutationFn = ApolloReactCommon.MutationFunction<ConcedeDisputeMutation, ConcedeDisputeMutationVariables>;
export type ConcedeDisputeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ConcedeDisputeMutation, ConcedeDisputeMutationVariables>, 'mutation'>;

    export const ConcedeDisputeComponent = (props: ConcedeDisputeComponentProps) => (
      <ApolloReactComponents.Mutation<ConcedeDisputeMutation, ConcedeDisputeMutationVariables> mutation={ConcedeDisputeDocument} {...props} />
    );
    
export type ConcedeDisputeProps<TChildProps = {}> = ApolloReactHoc.MutateProps<ConcedeDisputeMutation, ConcedeDisputeMutationVariables> & TChildProps;
export function withConcedeDispute<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ConcedeDisputeMutation,
  ConcedeDisputeMutationVariables,
  ConcedeDisputeProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, ConcedeDisputeMutation, ConcedeDisputeMutationVariables, ConcedeDisputeProps<TChildProps>>(ConcedeDisputeDocument, {
      alias: 'concedeDispute',
      ...operationOptions
    });
};
export type ConcedeDisputeMutationResult = ApolloReactCommon.MutationResult<ConcedeDisputeMutation>;
export type ConcedeDisputeMutationOptions = ApolloReactCommon.BaseMutationOptions<ConcedeDisputeMutation, ConcedeDisputeMutationVariables>;
export const DeletePersonDocument = gql`
    mutation deletePerson($input: DeletePersonInput!) {
  deletePerson(input: $input) {
    code
    message
    error
  }
}
    `;
export type DeletePersonMutationFn = ApolloReactCommon.MutationFunction<DeletePersonMutation, DeletePersonMutationVariables>;
export type DeletePersonComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeletePersonMutation, DeletePersonMutationVariables>, 'mutation'>;

    export const DeletePersonComponent = (props: DeletePersonComponentProps) => (
      <ApolloReactComponents.Mutation<DeletePersonMutation, DeletePersonMutationVariables> mutation={DeletePersonDocument} {...props} />
    );
    
export type DeletePersonProps<TChildProps = {}> = ApolloReactHoc.MutateProps<DeletePersonMutation, DeletePersonMutationVariables> & TChildProps;
export function withDeletePerson<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeletePersonMutation,
  DeletePersonMutationVariables,
  DeletePersonProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, DeletePersonMutation, DeletePersonMutationVariables, DeletePersonProps<TChildProps>>(DeletePersonDocument, {
      alias: 'deletePerson',
      ...operationOptions
    });
};
export type DeletePersonMutationResult = ApolloReactCommon.MutationResult<DeletePersonMutation>;
export type DeletePersonMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePersonMutation, DeletePersonMutationVariables>;
export const CreateRefundDocument = gql`
    mutation createRefund($input: CreateRefundInput!) {
  createRefund(input: $input) {
    code
    error
    message
  }
}
    `;
export type CreateRefundMutationFn = ApolloReactCommon.MutationFunction<CreateRefundMutation, CreateRefundMutationVariables>;
export type CreateRefundComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateRefundMutation, CreateRefundMutationVariables>, 'mutation'>;

    export const CreateRefundComponent = (props: CreateRefundComponentProps) => (
      <ApolloReactComponents.Mutation<CreateRefundMutation, CreateRefundMutationVariables> mutation={CreateRefundDocument} {...props} />
    );
    
export type CreateRefundProps<TChildProps = {}> = ApolloReactHoc.MutateProps<CreateRefundMutation, CreateRefundMutationVariables> & TChildProps;
export function withCreateRefund<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateRefundMutation,
  CreateRefundMutationVariables,
  CreateRefundProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, CreateRefundMutation, CreateRefundMutationVariables, CreateRefundProps<TChildProps>>(CreateRefundDocument, {
      alias: 'createRefund',
      ...operationOptions
    });
};
export type CreateRefundMutationResult = ApolloReactCommon.MutationResult<CreateRefundMutation>;
export type CreateRefundMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateRefundMutation, CreateRefundMutationVariables>;
export const SubmitVerificationDocument = gql`
    mutation submitVerification($input: SubmitVerificationInput!) {
  submitVerification(input: $input) {
    code
    message
    error
  }
}
    `;
export type SubmitVerificationMutationFn = ApolloReactCommon.MutationFunction<SubmitVerificationMutation, SubmitVerificationMutationVariables>;
export type SubmitVerificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitVerificationMutation, SubmitVerificationMutationVariables>, 'mutation'>;

    export const SubmitVerificationComponent = (props: SubmitVerificationComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitVerificationMutation, SubmitVerificationMutationVariables> mutation={SubmitVerificationDocument} {...props} />
    );
    
export type SubmitVerificationProps<TChildProps = {}> = ApolloReactHoc.MutateProps<SubmitVerificationMutation, SubmitVerificationMutationVariables> & TChildProps;
export function withSubmitVerification<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SubmitVerificationMutation,
  SubmitVerificationMutationVariables,
  SubmitVerificationProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, SubmitVerificationMutation, SubmitVerificationMutationVariables, SubmitVerificationProps<TChildProps>>(SubmitVerificationDocument, {
      alias: 'submitVerification',
      ...operationOptions
    });
};
export type SubmitVerificationMutationResult = ApolloReactCommon.MutationResult<SubmitVerificationMutation>;
export type SubmitVerificationMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitVerificationMutation, SubmitVerificationMutationVariables>;
export const UploadDocumentDocument = gql`
    mutation uploadDocument($input: UploadInput!) {
  upload(input: $input) {
    uniqueId
  }
}
    `;
export type UploadDocumentMutationFn = ApolloReactCommon.MutationFunction<UploadDocumentMutation, UploadDocumentMutationVariables>;
export type UploadDocumentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UploadDocumentMutation, UploadDocumentMutationVariables>, 'mutation'>;

    export const UploadDocumentComponent = (props: UploadDocumentComponentProps) => (
      <ApolloReactComponents.Mutation<UploadDocumentMutation, UploadDocumentMutationVariables> mutation={UploadDocumentDocument} {...props} />
    );
    
export type UploadDocumentProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UploadDocumentMutation, UploadDocumentMutationVariables> & TChildProps;
export function withUploadDocument<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UploadDocumentMutation,
  UploadDocumentMutationVariables,
  UploadDocumentProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UploadDocumentMutation, UploadDocumentMutationVariables, UploadDocumentProps<TChildProps>>(UploadDocumentDocument, {
      alias: 'uploadDocument',
      ...operationOptions
    });
};
export type UploadDocumentMutationResult = ApolloReactCommon.MutationResult<UploadDocumentMutation>;
export type UploadDocumentMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadDocumentMutation, UploadDocumentMutationVariables>;
export const UpsertBusinessUrlDocument = gql`
    mutation upsertBusinessUrl($input: UpsertTenantAccountInput!) {
  upsertTenantAccount(input: $input) {
    code
    message
    error
  }
}
    `;
export type UpsertBusinessUrlMutationFn = ApolloReactCommon.MutationFunction<UpsertBusinessUrlMutation, UpsertBusinessUrlMutationVariables>;
export type UpsertBusinessUrlComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertBusinessUrlMutation, UpsertBusinessUrlMutationVariables>, 'mutation'>;

    export const UpsertBusinessUrlComponent = (props: UpsertBusinessUrlComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertBusinessUrlMutation, UpsertBusinessUrlMutationVariables> mutation={UpsertBusinessUrlDocument} {...props} />
    );
    
export type UpsertBusinessUrlProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpsertBusinessUrlMutation, UpsertBusinessUrlMutationVariables> & TChildProps;
export function withUpsertBusinessUrl<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertBusinessUrlMutation,
  UpsertBusinessUrlMutationVariables,
  UpsertBusinessUrlProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertBusinessUrlMutation, UpsertBusinessUrlMutationVariables, UpsertBusinessUrlProps<TChildProps>>(UpsertBusinessUrlDocument, {
      alias: 'upsertBusinessUrl',
      ...operationOptions
    });
};
export type UpsertBusinessUrlMutationResult = ApolloReactCommon.MutationResult<UpsertBusinessUrlMutation>;
export type UpsertBusinessUrlMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertBusinessUrlMutation, UpsertBusinessUrlMutationVariables>;
export const UpsertPaymentRequestDocument = gql`
    mutation upsertPaymentRequest($input: UpsertPaymentRequestInput!) {
  upsertPaymentRequest(input: $input) {
    code
    message
    paymentRequestId
    error
  }
}
    `;
export type UpsertPaymentRequestMutationFn = ApolloReactCommon.MutationFunction<UpsertPaymentRequestMutation, UpsertPaymentRequestMutationVariables>;
export type UpsertPaymentRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertPaymentRequestMutation, UpsertPaymentRequestMutationVariables>, 'mutation'>;

    export const UpsertPaymentRequestComponent = (props: UpsertPaymentRequestComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertPaymentRequestMutation, UpsertPaymentRequestMutationVariables> mutation={UpsertPaymentRequestDocument} {...props} />
    );
    
export type UpsertPaymentRequestProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpsertPaymentRequestMutation, UpsertPaymentRequestMutationVariables> & TChildProps;
export function withUpsertPaymentRequest<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertPaymentRequestMutation,
  UpsertPaymentRequestMutationVariables,
  UpsertPaymentRequestProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertPaymentRequestMutation, UpsertPaymentRequestMutationVariables, UpsertPaymentRequestProps<TChildProps>>(UpsertPaymentRequestDocument, {
      alias: 'upsertPaymentRequest',
      ...operationOptions
    });
};
export type UpsertPaymentRequestMutationResult = ApolloReactCommon.MutationResult<UpsertPaymentRequestMutation>;
export type UpsertPaymentRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertPaymentRequestMutation, UpsertPaymentRequestMutationVariables>;
export const UpsertPayoutFrequencyDocument = gql`
    mutation upsertPayoutFrequency($input: UpsertPayoutFrequencyInput!) {
  upsertPayoutFrequency(input: $input) {
    code
    message
  }
}
    `;
export type UpsertPayoutFrequencyMutationFn = ApolloReactCommon.MutationFunction<UpsertPayoutFrequencyMutation, UpsertPayoutFrequencyMutationVariables>;
export type UpsertPayoutFrequencyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertPayoutFrequencyMutation, UpsertPayoutFrequencyMutationVariables>, 'mutation'>;

    export const UpsertPayoutFrequencyComponent = (props: UpsertPayoutFrequencyComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertPayoutFrequencyMutation, UpsertPayoutFrequencyMutationVariables> mutation={UpsertPayoutFrequencyDocument} {...props} />
    );
    
export type UpsertPayoutFrequencyProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpsertPayoutFrequencyMutation, UpsertPayoutFrequencyMutationVariables> & TChildProps;
export function withUpsertPayoutFrequency<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertPayoutFrequencyMutation,
  UpsertPayoutFrequencyMutationVariables,
  UpsertPayoutFrequencyProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertPayoutFrequencyMutation, UpsertPayoutFrequencyMutationVariables, UpsertPayoutFrequencyProps<TChildProps>>(UpsertPayoutFrequencyDocument, {
      alias: 'upsertPayoutFrequency',
      ...operationOptions
    });
};
export type UpsertPayoutFrequencyMutationResult = ApolloReactCommon.MutationResult<UpsertPayoutFrequencyMutation>;
export type UpsertPayoutFrequencyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertPayoutFrequencyMutation, UpsertPayoutFrequencyMutationVariables>;
export const UpsertPayoutSettingsDocument = gql`
    mutation upsertPayoutSettings($input: UpsertPayoutSettingsInput!) {
  upsertPayoutSettings(input: $input) {
    code
    message
  }
}
    `;
export type UpsertPayoutSettingsMutationFn = ApolloReactCommon.MutationFunction<UpsertPayoutSettingsMutation, UpsertPayoutSettingsMutationVariables>;
export type UpsertPayoutSettingsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertPayoutSettingsMutation, UpsertPayoutSettingsMutationVariables>, 'mutation'>;

    export const UpsertPayoutSettingsComponent = (props: UpsertPayoutSettingsComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertPayoutSettingsMutation, UpsertPayoutSettingsMutationVariables> mutation={UpsertPayoutSettingsDocument} {...props} />
    );
    
export type UpsertPayoutSettingsProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpsertPayoutSettingsMutation, UpsertPayoutSettingsMutationVariables> & TChildProps;
export function withUpsertPayoutSettings<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertPayoutSettingsMutation,
  UpsertPayoutSettingsMutationVariables,
  UpsertPayoutSettingsProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertPayoutSettingsMutation, UpsertPayoutSettingsMutationVariables, UpsertPayoutSettingsProps<TChildProps>>(UpsertPayoutSettingsDocument, {
      alias: 'upsertPayoutSettings',
      ...operationOptions
    });
};
export type UpsertPayoutSettingsMutationResult = ApolloReactCommon.MutationResult<UpsertPayoutSettingsMutation>;
export type UpsertPayoutSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertPayoutSettingsMutation, UpsertPayoutSettingsMutationVariables>;
export const UpsertPersonDocument = gql`
    mutation upsertPerson($input: UpsertPersonInput!) {
  upsertPerson(input: $input) {
    code
    message
    error
  }
}
    `;
export type UpsertPersonMutationFn = ApolloReactCommon.MutationFunction<UpsertPersonMutation, UpsertPersonMutationVariables>;
export type UpsertPersonComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertPersonMutation, UpsertPersonMutationVariables>, 'mutation'>;

    export const UpsertPersonComponent = (props: UpsertPersonComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertPersonMutation, UpsertPersonMutationVariables> mutation={UpsertPersonDocument} {...props} />
    );
    
export type UpsertPersonProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpsertPersonMutation, UpsertPersonMutationVariables> & TChildProps;
export function withUpsertPerson<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertPersonMutation,
  UpsertPersonMutationVariables,
  UpsertPersonProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertPersonMutation, UpsertPersonMutationVariables, UpsertPersonProps<TChildProps>>(UpsertPersonDocument, {
      alias: 'upsertPerson',
      ...operationOptions
    });
};
export type UpsertPersonMutationResult = ApolloReactCommon.MutationResult<UpsertPersonMutation>;
export type UpsertPersonMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertPersonMutation, UpsertPersonMutationVariables>;
export const UpsertRefundPolicyDocument = gql`
    mutation upsertRefundPolicy($input: UpsertTenantAccountInput!) {
  upsertTenantAccount(input: $input) {
    code
    message
    error
  }
}
    `;
export type UpsertRefundPolicyMutationFn = ApolloReactCommon.MutationFunction<UpsertRefundPolicyMutation, UpsertRefundPolicyMutationVariables>;
export type UpsertRefundPolicyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertRefundPolicyMutation, UpsertRefundPolicyMutationVariables>, 'mutation'>;

    export const UpsertRefundPolicyComponent = (props: UpsertRefundPolicyComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertRefundPolicyMutation, UpsertRefundPolicyMutationVariables> mutation={UpsertRefundPolicyDocument} {...props} />
    );
    
export type UpsertRefundPolicyProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpsertRefundPolicyMutation, UpsertRefundPolicyMutationVariables> & TChildProps;
export function withUpsertRefundPolicy<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertRefundPolicyMutation,
  UpsertRefundPolicyMutationVariables,
  UpsertRefundPolicyProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertRefundPolicyMutation, UpsertRefundPolicyMutationVariables, UpsertRefundPolicyProps<TChildProps>>(UpsertRefundPolicyDocument, {
      alias: 'upsertRefundPolicy',
      ...operationOptions
    });
};
export type UpsertRefundPolicyMutationResult = ApolloReactCommon.MutationResult<UpsertRefundPolicyMutation>;
export type UpsertRefundPolicyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertRefundPolicyMutation, UpsertRefundPolicyMutationVariables>;
export const UpsertStatementDescriptionDocument = gql`
    mutation upsertStatementDescription($input: UpsertTenantAccountInput!) {
  upsertTenantAccount(input: $input) {
    code
    message
    error
  }
}
    `;
export type UpsertStatementDescriptionMutationFn = ApolloReactCommon.MutationFunction<UpsertStatementDescriptionMutation, UpsertStatementDescriptionMutationVariables>;
export type UpsertStatementDescriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertStatementDescriptionMutation, UpsertStatementDescriptionMutationVariables>, 'mutation'>;

    export const UpsertStatementDescriptionComponent = (props: UpsertStatementDescriptionComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertStatementDescriptionMutation, UpsertStatementDescriptionMutationVariables> mutation={UpsertStatementDescriptionDocument} {...props} />
    );
    
export type UpsertStatementDescriptionProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpsertStatementDescriptionMutation, UpsertStatementDescriptionMutationVariables> & TChildProps;
export function withUpsertStatementDescription<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertStatementDescriptionMutation,
  UpsertStatementDescriptionMutationVariables,
  UpsertStatementDescriptionProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertStatementDescriptionMutation, UpsertStatementDescriptionMutationVariables, UpsertStatementDescriptionProps<TChildProps>>(UpsertStatementDescriptionDocument, {
      alias: 'upsertStatementDescription',
      ...operationOptions
    });
};
export type UpsertStatementDescriptionMutationResult = ApolloReactCommon.MutationResult<UpsertStatementDescriptionMutation>;
export type UpsertStatementDescriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertStatementDescriptionMutation, UpsertStatementDescriptionMutationVariables>;
export const UpsertSupportEmailDocument = gql`
    mutation upsertSupportEmail($input: UpsertTenantAccountInput!) {
  upsertTenantAccount(input: $input) {
    code
    message
    error
  }
}
    `;
export type UpsertSupportEmailMutationFn = ApolloReactCommon.MutationFunction<UpsertSupportEmailMutation, UpsertSupportEmailMutationVariables>;
export type UpsertSupportEmailComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertSupportEmailMutation, UpsertSupportEmailMutationVariables>, 'mutation'>;

    export const UpsertSupportEmailComponent = (props: UpsertSupportEmailComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertSupportEmailMutation, UpsertSupportEmailMutationVariables> mutation={UpsertSupportEmailDocument} {...props} />
    );
    
export type UpsertSupportEmailProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpsertSupportEmailMutation, UpsertSupportEmailMutationVariables> & TChildProps;
export function withUpsertSupportEmail<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertSupportEmailMutation,
  UpsertSupportEmailMutationVariables,
  UpsertSupportEmailProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertSupportEmailMutation, UpsertSupportEmailMutationVariables, UpsertSupportEmailProps<TChildProps>>(UpsertSupportEmailDocument, {
      alias: 'upsertSupportEmail',
      ...operationOptions
    });
};
export type UpsertSupportEmailMutationResult = ApolloReactCommon.MutationResult<UpsertSupportEmailMutation>;
export type UpsertSupportEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertSupportEmailMutation, UpsertSupportEmailMutationVariables>;
export const UpsertTenantAccountDocument = gql`
    mutation upsertTenantAccount($input: UpsertTenantAccountInput!) {
  upsertTenantAccount(input: $input) {
    code
    message
  }
}
    `;
export type UpsertTenantAccountMutationFn = ApolloReactCommon.MutationFunction<UpsertTenantAccountMutation, UpsertTenantAccountMutationVariables>;
export type UpsertTenantAccountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertTenantAccountMutation, UpsertTenantAccountMutationVariables>, 'mutation'>;

    export const UpsertTenantAccountComponent = (props: UpsertTenantAccountComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertTenantAccountMutation, UpsertTenantAccountMutationVariables> mutation={UpsertTenantAccountDocument} {...props} />
    );
    
export type UpsertTenantAccountProps<TChildProps = {}> = ApolloReactHoc.MutateProps<UpsertTenantAccountMutation, UpsertTenantAccountMutationVariables> & TChildProps;
export function withUpsertTenantAccount<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertTenantAccountMutation,
  UpsertTenantAccountMutationVariables,
  UpsertTenantAccountProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertTenantAccountMutation, UpsertTenantAccountMutationVariables, UpsertTenantAccountProps<TChildProps>>(UpsertTenantAccountDocument, {
      alias: 'upsertTenantAccount',
      ...operationOptions
    });
};
export type UpsertTenantAccountMutationResult = ApolloReactCommon.MutationResult<UpsertTenantAccountMutation>;
export type UpsertTenantAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertTenantAccountMutation, UpsertTenantAccountMutationVariables>;
export const GetAdditionalVerifcationsDocument = gql`
    query getAdditionalVerifcations {
  account {
    requirements {
      currentDeadline
      currentlyDue
      disabledReason
      errors
      eventuallyDue
      pastDue
      pendingVerification
    }
  }
}
    `;
export type GetAdditionalVerifcationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAdditionalVerifcationsQuery, GetAdditionalVerifcationsQueryVariables>, 'query'>;

    export const GetAdditionalVerifcationsComponent = (props: GetAdditionalVerifcationsComponentProps) => (
      <ApolloReactComponents.Query<GetAdditionalVerifcationsQuery, GetAdditionalVerifcationsQueryVariables> query={GetAdditionalVerifcationsDocument} {...props} />
    );
    
export type GetAdditionalVerifcationsProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetAdditionalVerifcationsQuery, GetAdditionalVerifcationsQueryVariables> & TChildProps;
export function withGetAdditionalVerifcations<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAdditionalVerifcationsQuery,
  GetAdditionalVerifcationsQueryVariables,
  GetAdditionalVerifcationsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetAdditionalVerifcationsQuery, GetAdditionalVerifcationsQueryVariables, GetAdditionalVerifcationsProps<TChildProps>>(GetAdditionalVerifcationsDocument, {
      alias: 'getAdditionalVerifcations',
      ...operationOptions
    });
};
export type GetAdditionalVerifcationsQueryResult = ApolloReactCommon.QueryResult<GetAdditionalVerifcationsQuery, GetAdditionalVerifcationsQueryVariables>;
export const DisputesDocument = gql`
    query disputes($after: String, $before: String, $first: Int, $last: Int, $orderBy: DisputeOrder!) {
  disputes(after: $after, before: $before, first: $first, last: $last, orderBy: $orderBy) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    nodes {
      amount
      status
      disputeType
      currency
      reason
      reasonMessage
      reasonDetails {
        code
        message
      }
      createdAt
      id
      resolution
      resolvedAt
      concedeMessage
      owner {
        paymentId
        tenantId
      }
    }
    edges {
      cursor
      node {
        id
      }
    }
  }
}
    `;
export type DisputesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DisputesQuery, DisputesQueryVariables>, 'query'> & ({ variables: DisputesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DisputesComponent = (props: DisputesComponentProps) => (
      <ApolloReactComponents.Query<DisputesQuery, DisputesQueryVariables> query={DisputesDocument} {...props} />
    );
    
export type DisputesProps<TChildProps = {}> = ApolloReactHoc.DataProps<DisputesQuery, DisputesQueryVariables> & TChildProps;
export function withDisputes<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DisputesQuery,
  DisputesQueryVariables,
  DisputesProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, DisputesQuery, DisputesQueryVariables, DisputesProps<TChildProps>>(DisputesDocument, {
      alias: 'disputes',
      ...operationOptions
    });
};
export type DisputesQueryResult = ApolloReactCommon.QueryResult<DisputesQuery, DisputesQueryVariables>;
export const GetOwningProductDocument = gql`
    query getOwningProduct {
  account {
    owningProduct
  }
}
    `;
export type GetOwningProductComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetOwningProductQuery, GetOwningProductQueryVariables>, 'query'>;

    export const GetOwningProductComponent = (props: GetOwningProductComponentProps) => (
      <ApolloReactComponents.Query<GetOwningProductQuery, GetOwningProductQueryVariables> query={GetOwningProductDocument} {...props} />
    );
    
export type GetOwningProductProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetOwningProductQuery, GetOwningProductQueryVariables> & TChildProps;
export function withGetOwningProduct<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetOwningProductQuery,
  GetOwningProductQueryVariables,
  GetOwningProductProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetOwningProductQuery, GetOwningProductQueryVariables, GetOwningProductProps<TChildProps>>(GetOwningProductDocument, {
      alias: 'getOwningProduct',
      ...operationOptions
    });
};
export type GetOwningProductQueryResult = ApolloReactCommon.QueryResult<GetOwningProductQuery, GetOwningProductQueryVariables>;
export const PaymentsDocument = gql`
    query payments($after: String, $before: String, $first: Int, $last: Int, $orderBy: PaymentOrder!, $queryString: String) {
  payments(after: $after, before: $before, first: $first, last: $last, orderBy: $orderBy, queryString: $queryString) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    nodes {
      id
      status
      pendingReason
      amount
      amountDisputed
      amountRefunded
      attemptTimestamp
      completedTimestamp
      createdAt
      cancelReason
      currency
      failureReason
      feeAmount
      immediateCapture
      initiatedBy
      owner {
        tenantId
        paymentRequestId
      }
      refunds {
        amount
        attemptTimestamp
        currency
        id
        refundReason
        status
        createTime
        owner {
          tenantId
        }
        payment {
          id
          amount
        }
      }
      paymentRequest {
        amount
        communications {
          communicationType
          email
          phoneNumber
          requestTimestamp
          sentTimestamp
        }
        createdAt
        createdBy
        id
        invoiceLink
        invoiceId
        referenceNumber
        status
        statusReason
        payments {
          id
          status
          amount
          amountRefunded
        }
        owner {
          paymentId
          tenantId
          disputeId
        }
      }
    }
    edges {
      cursor
      node {
        id
      }
    }
  }
}
    `;
export type PaymentsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PaymentsQuery, PaymentsQueryVariables>, 'query'> & ({ variables: PaymentsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PaymentsComponent = (props: PaymentsComponentProps) => (
      <ApolloReactComponents.Query<PaymentsQuery, PaymentsQueryVariables> query={PaymentsDocument} {...props} />
    );
    
export type PaymentsProps<TChildProps = {}> = ApolloReactHoc.DataProps<PaymentsQuery, PaymentsQueryVariables> & TChildProps;
export function withPayments<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PaymentsQuery,
  PaymentsQueryVariables,
  PaymentsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, PaymentsQuery, PaymentsQueryVariables, PaymentsProps<TChildProps>>(PaymentsDocument, {
      alias: 'payments',
      ...operationOptions
    });
};
export type PaymentsQueryResult = ApolloReactCommon.QueryResult<PaymentsQuery, PaymentsQueryVariables>;
export const PaymentRequestsDocument = gql`
    query paymentRequests($after: String, $before: String, $first: Int, $last: Int, $orderBy: PaymentRequestOrder!, $queryString: String) {
  paymentRequests(after: $after, before: $before, first: $first, last: $last, orderBy: $orderBy, queryString: $queryString) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    nodes {
      amount
      communications {
        communicationType
        email
        phoneNumber
        requestTimestamp
        sentTimestamp
      }
      createdAt
      createdBy
      id
      invoiceLink
      invoiceId
      referenceNumber
      status
      statusReason
      payments {
        id
        status
        amount
        amountRefunded
      }
      owner {
        paymentId
        tenantId
        disputeId
      }
    }
    edges {
      cursor
      node {
        id
      }
    }
  }
}
    `;
export type PaymentRequestsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PaymentRequestsQuery, PaymentRequestsQueryVariables>, 'query'> & ({ variables: PaymentRequestsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PaymentRequestsComponent = (props: PaymentRequestsComponentProps) => (
      <ApolloReactComponents.Query<PaymentRequestsQuery, PaymentRequestsQueryVariables> query={PaymentRequestsDocument} {...props} />
    );
    
export type PaymentRequestsProps<TChildProps = {}> = ApolloReactHoc.DataProps<PaymentRequestsQuery, PaymentRequestsQueryVariables> & TChildProps;
export function withPaymentRequests<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PaymentRequestsQuery,
  PaymentRequestsQueryVariables,
  PaymentRequestsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, PaymentRequestsQuery, PaymentRequestsQueryVariables, PaymentRequestsProps<TChildProps>>(PaymentRequestsDocument, {
      alias: 'paymentRequests',
      ...operationOptions
    });
};
export type PaymentRequestsQueryResult = ApolloReactCommon.QueryResult<PaymentRequestsQuery, PaymentRequestsQueryVariables>;
export const PayoutSettingsDocument = gql`
    query payoutSettings {
  account {
    settings {
      accountPayouts {
        accountType
        accountLastFour
        currency
        schedule {
          interval
        }
        statementDescription
        status
      }
    }
  }
}
    `;
export type PayoutSettingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PayoutSettingsQuery, PayoutSettingsQueryVariables>, 'query'>;

    export const PayoutSettingsComponent = (props: PayoutSettingsComponentProps) => (
      <ApolloReactComponents.Query<PayoutSettingsQuery, PayoutSettingsQueryVariables> query={PayoutSettingsDocument} {...props} />
    );
    
export type PayoutSettingsProps<TChildProps = {}> = ApolloReactHoc.DataProps<PayoutSettingsQuery, PayoutSettingsQueryVariables> & TChildProps;
export function withPayoutSettings<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PayoutSettingsQuery,
  PayoutSettingsQueryVariables,
  PayoutSettingsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, PayoutSettingsQuery, PayoutSettingsQueryVariables, PayoutSettingsProps<TChildProps>>(PayoutSettingsDocument, {
      alias: 'payoutSettings',
      ...operationOptions
    });
};
export type PayoutSettingsQueryResult = ApolloReactCommon.QueryResult<PayoutSettingsQuery, PayoutSettingsQueryVariables>;
export const GetPersonByEmailDocument = gql`
    query getPersonByEmail($email: String!) {
  person(email: $email) {
    id
    firstName
    lastName
    email
    relationship {
      role
    }
    owner {
      tenantId
    }
  }
}
    `;
export type GetPersonByEmailComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPersonByEmailQuery, GetPersonByEmailQueryVariables>, 'query'> & ({ variables: GetPersonByEmailQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetPersonByEmailComponent = (props: GetPersonByEmailComponentProps) => (
      <ApolloReactComponents.Query<GetPersonByEmailQuery, GetPersonByEmailQueryVariables> query={GetPersonByEmailDocument} {...props} />
    );
    
export type GetPersonByEmailProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetPersonByEmailQuery, GetPersonByEmailQueryVariables> & TChildProps;
export function withGetPersonByEmail<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPersonByEmailQuery,
  GetPersonByEmailQueryVariables,
  GetPersonByEmailProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetPersonByEmailQuery, GetPersonByEmailQueryVariables, GetPersonByEmailProps<TChildProps>>(GetPersonByEmailDocument, {
      alias: 'getPersonByEmail',
      ...operationOptions
    });
};
export type GetPersonByEmailQueryResult = ApolloReactCommon.QueryResult<GetPersonByEmailQuery, GetPersonByEmailQueryVariables>;
export const PersonsListDocument = gql`
    query personsList {
  persons {
    firstName
    lastName
    email
    relationship {
      owner
      primaryAccountHolder
      role
      involvement
    }
    verification {
      status
    }
    updatedAt
    id
    createdAt
  }
}
    `;
export type PersonsListComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PersonsListQuery, PersonsListQueryVariables>, 'query'>;

    export const PersonsListComponent = (props: PersonsListComponentProps) => (
      <ApolloReactComponents.Query<PersonsListQuery, PersonsListQueryVariables> query={PersonsListDocument} {...props} />
    );
    
export type PersonsListProps<TChildProps = {}> = ApolloReactHoc.DataProps<PersonsListQuery, PersonsListQueryVariables> & TChildProps;
export function withPersonsList<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PersonsListQuery,
  PersonsListQueryVariables,
  PersonsListProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, PersonsListQuery, PersonsListQueryVariables, PersonsListProps<TChildProps>>(PersonsListDocument, {
      alias: 'personsList',
      ...operationOptions
    });
};
export type PersonsListQueryResult = ApolloReactCommon.QueryResult<PersonsListQuery, PersonsListQueryVariables>;
export const GetTenantAccountDocument = gql`
    query getTenantAccount {
  account {
    country
    createdAt
    id
    owner {
      tenantId
    }
    updatedAt
    email
    payfac {
      ids {
        resourceId
        resourceType
      }
    }
    capabilities {
      cardPayments
      achPayments
      accountPayouts
    }
    businessProfile {
      description
      name
      url
      supportEmail
      mcc
    }
    businessType
    company {
      address {
        city
        country
        line1
        line2
        postalCode
        region
      }
      description
      name
      phone {
        countryCode
        number
        phoneNumber
      }
      structure
      verification {
        status
        additionalDocuments {
          documentId
          rejectReason
          status
          type
        }
        documents {
          documentId
          rejectReason
          status
          type
        }
      }
    }
    settings {
      cardPayments {
        refundPolicy
        statementDescription
      }
      achPayments {
        refundPolicy
        statementDescription
      }
      accountPayouts {
        statementDescription
        status
        schedule {
          interval
        }
        currency
        accountType
        accountLastFour
      }
    }
    statements {
      createdAt
      startTime
      endTime
      url
    }
    requirements {
      pastDue
      currentlyDue
      pendingVerification
      eventuallyDue
    }
    tosAcceptance {
      date
    }
    defaultCurrency
    balances {
      balance
      incomingPending
      outgoingPending
      reserve
      updatedTimestamp
    }
    feeSchedule
    errors
  }
}
    `;
export type GetTenantAccountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTenantAccountQuery, GetTenantAccountQueryVariables>, 'query'>;

    export const GetTenantAccountComponent = (props: GetTenantAccountComponentProps) => (
      <ApolloReactComponents.Query<GetTenantAccountQuery, GetTenantAccountQueryVariables> query={GetTenantAccountDocument} {...props} />
    );
    
export type GetTenantAccountProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetTenantAccountQuery, GetTenantAccountQueryVariables> & TChildProps;
export function withGetTenantAccount<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTenantAccountQuery,
  GetTenantAccountQueryVariables,
  GetTenantAccountProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetTenantAccountQuery, GetTenantAccountQueryVariables, GetTenantAccountProps<TChildProps>>(GetTenantAccountDocument, {
      alias: 'getTenantAccount',
      ...operationOptions
    });
};
export type GetTenantAccountQueryResult = ApolloReactCommon.QueryResult<GetTenantAccountQuery, GetTenantAccountQueryVariables>;
export const TransactionRecordsDocument = gql`
    query transactionRecords($after: String, $before: String, $first: Int, $last: Int, $orderBy: TransactionRecordOrder!, $startDate: DateTime, $endDate: DateTime) {
  transactionRecords(after: $after, before: $before, first: $first, last: $last, orderBy: $orderBy, startDate: $startDate, endDate: $endDate) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
      __typename
    }
    nodes {
      createdAt
      id
      transactionType
      grossAmount
      feeAmount
      netAmount
      __typename
    }
    edges {
      cursor
      node {
        id
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;
export type TransactionRecordsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TransactionRecordsQuery, TransactionRecordsQueryVariables>, 'query'> & ({ variables: TransactionRecordsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TransactionRecordsComponent = (props: TransactionRecordsComponentProps) => (
      <ApolloReactComponents.Query<TransactionRecordsQuery, TransactionRecordsQueryVariables> query={TransactionRecordsDocument} {...props} />
    );
    
export type TransactionRecordsProps<TChildProps = {}> = ApolloReactHoc.DataProps<TransactionRecordsQuery, TransactionRecordsQueryVariables> & TChildProps;
export function withTransactionRecords<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TransactionRecordsQuery,
  TransactionRecordsQueryVariables,
  TransactionRecordsProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, TransactionRecordsQuery, TransactionRecordsQueryVariables, TransactionRecordsProps<TChildProps>>(TransactionRecordsDocument, {
      alias: 'transactionRecords',
      ...operationOptions
    });
};
export type TransactionRecordsQueryResult = ApolloReactCommon.QueryResult<TransactionRecordsQuery, TransactionRecordsQueryVariables>;
export const GetViewerUserDocument = gql`
    query getViewerUser {
  viewer {
    currentUser {
      id
      firstName
      lastName
      email
      relationship {
        role
      }
    }
  }
}
    `;
export type GetViewerUserComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetViewerUserQuery, GetViewerUserQueryVariables>, 'query'>;

    export const GetViewerUserComponent = (props: GetViewerUserComponentProps) => (
      <ApolloReactComponents.Query<GetViewerUserQuery, GetViewerUserQueryVariables> query={GetViewerUserDocument} {...props} />
    );
    
export type GetViewerUserProps<TChildProps = {}> = ApolloReactHoc.DataProps<GetViewerUserQuery, GetViewerUserQueryVariables> & TChildProps;
export function withGetViewerUser<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetViewerUserQuery,
  GetViewerUserQueryVariables,
  GetViewerUserProps<TChildProps>>) {
    return ApolloReactHoc.withQuery<TProps, GetViewerUserQuery, GetViewerUserQueryVariables, GetViewerUserProps<TChildProps>>(GetViewerUserDocument, {
      alias: 'getViewerUser',
      ...operationOptions
    });
};
export type GetViewerUserQueryResult = ApolloReactCommon.QueryResult<GetViewerUserQuery, GetViewerUserQueryVariables>;